{
  "app": {
    "name": "miraCMS 2.0",
    "tagline": "Click-to-Edit Editor"
  },
  "audit": {
    "title": "Audit log",
    "hint": "Who changed what, and when. Append-only, secured with a hash chain.",
    "chainBroken": "Warning: the audit log was tampered with (from line {line}). Please review immediately.",
    "empty": "No entries yet.",
    "loading": "Loading …",
    "more": "Load more",
    "all": "All",
    "days7": "Last 7 days",
    "days30": "Last 30 days",
    "days90": "Last 90 days",
    "count": "{n} entry | {n} entries",
    "filterProject": "Project",
    "filterPeriod": "Period",
    "filterActor": "Person",
    "colWhen": "When",
    "colWho": "Who",
    "colWhat": "What",
    "colProject": "Project",
    "outcome": {
      "denied": "denied",
      "failed": "failed"
    },
    "area": {
      "project": "Project",
      "user": "Account",
      "auth": "Sign-in",
      "gate_texts": "Preview page"
    },
    "verb": {
      "saved": "Saved",
      "created": "Created",
      "updated": "Updated",
      "deleted": "Deleted",
      "publish": "Published",
      "promote": "Promoted to live",
      "login": "Signed in",
      "logout": "Signed out",
      "password_changed": "Password changed",
      "upload": "Uploaded",
      "restore": "Restored",
      "reorder": "Reordered",
      "save": "Saved",
      "totp": "Second factor confirmed",
      "gast": "Signed in via comment link",
      "annotations": "Comment",
      "replies": "Reply to comment",
      "anhaenge": "Comment attachment",
      "gast-link": "Comment link",
      "items": "Catalog entry",
      "module": "Access changed",
      "rebuild": "Preview rebuilt",
      "seiten": "Page",
      "share": "Preview link",
      "upload-file": "File uploaded",
      "password": "Password changed"
    }
  },
  "update": {
    "available": "A new version is available.",
    "action": "Update now"
  },
  "changelog": {
    "title": "New since your last update",
    "dismiss": "Dismiss",
    "entries": {
      "premium-wirkung": "New for pages built from blocks: an eyebrow above every heading, edge-to-edge “Text with image” with glass cards, benefits as glass cards, a full-screen hero with a large heading and a scroll hint, and buttons with a thin outline in your accent colour.",
      "kopf-ueber-bild-hell": "The header can now sit see-through on the hero image with light styles too, with white text and the light version of your logo.",
      "bild-im-chat": "In the Assistant chat you can now attach up to three of your own images. They go into the media library, and Claude sees them before placing and describing them.",
      "baustein-gutschein": "New block “Gift voucher”: a voucher card in your colours with your business name, next to a text and a button to buy.",
      "baustein-buchung": "New block “Book online”: it shows your offers with duration and price straight from your online booking, each with a button to book. Prices are now kept there only.",
      "kopf-ueber-bild": "On websites with a dark page background, the header can now sit see-through on the hero image. Switch it on under Design; the style “Refined & dark” does it for you.",
      "abdunklung-waehlbar": "Where text sits on an image, in the hero or as a section background, the section menu now lets you choose how much the image is darkened: light, normal or strong.",
      "stil-edel-dunkel": "New style “Refined & dark”: the whole website dark, lavender and gold, fine serifs. Under Design you can also switch on a starry sky as a background pattern.",
      "vorschau-link-cloudflare": "The preview link now also works for websites at Cloudflare. It opens the preview in the browser, on phones too, and you can send it on to your customer.",
      "claude-ganze-seite": "Where the Assistant is enabled, Claude can build a whole page in one step and arrange the menu. Below you see what the conversation has cost so far.",
      "claude-gestaltung": "Where the Assistant is enabled, Claude can now change the look too: style, colours and fonts, like everything else only in the preview.",
      "stockfotos": "The image field now has a Stock photos tab: search Pexels and Pixabay and add a photo with one click. Where the Assistant is enabled, Claude can find and place photos too.",
      "neue-bausteine-premium": "New blocks for key figures, benefits, a quote and a wide image, plus images in the hero, as background of any section and per service or price.",
      "stilrichtungen": "Design now offers ready-made styles that set colours, fonts and corners together, and a separate font for headings.",
      "bild-alle-sprachen": "You now replace an image in a section once, and it applies to every language of the page. The image description stays per language.",
      "mediathek": "The new media library shows every image in the project and where it is used; “From media library” puts an existing image into an image field instead of uploading it again, and uploaded images that are no longer used anywhere can be deleted there.",
      "vorabpruefung": "Before “Publish”, miraCMS now checks the website: placeholders must be replaced, missing image descriptions and heading issues are listed as recommendations, and a click leads to the spot.",
      "neue-bausteine": "Websites built from building blocks get eight new ones: gallery, price list, team, opening hours, map, contact form, video and reviews.",
      "rueckgaengig": "Changes to the page structure can be undone: press Cmd+Z or the arrow below the sections, and Cmd+Shift+Z redoes them.",
      "menue-und-adresse": "You now manage the website menu yourself with “Edit menu” below the page list, and pages built from building blocks can get a new address while old links redirect.",
      "assistent-im-panel": "Where miraTEQ enables it, the right panel has an “Assistant” tab: you write what should change and Claude does it in the preview.",
      "seitenwechsel-ohne-speichern": "You can switch pages without saving first: unsaved changes stay, a dot in the page list shows where, and Save stores everything at once.",
      "umbauten-sofort": "Changes to sections now show up instantly, and after saving the preview updates without jumping back to the top.",
      "seiten-aus-bausteinen": "On websites built from building blocks, the new “Sections” tab lets you add, move and delete sections and whole pages.",
      "verlauf-mit-namen": "The history of a field now shows who made each new change.",
      "bildbeschreibung-pruefen": "After you replace an image, its image description says “Please check” until you adjust it or confirm it with “Still fits”.",
      "neue-website": "You can now create new customer websites yourself in the panel: “New website” in the project list, then “Setup” in the project for the domain, contact form and customer approval. You confirm sensitive steps with the code from your app.",
      "schrift-und-ecken": "Under Colours you can now also choose the font and corners, and a brand colour that is too light automatically gets a readable shade for buttons.",
      "schrift-editor": "Texts in sections can now be styled: bold, italic, as a link, in brand or accent colour, muted, larger or smaller, and highlighted.",
      "schrift-und-farben": "Under colours you can now set the size, weight and letter spacing of headings, the text size, an accent colour and the page background, and sections can also be fully in the brand colour.",
      "abschnitt-einstellungen": "In the menu of a section you can now set its spacing, give it an anchor that a button can jump to, or hide it without deleting it.",
      "knoepfe-kopf-social": "Under colours you can now choose the button style and whether the header stays on top while scrolling; add Instagram, Facebook, LINE and other profiles in the fields for all pages, and they appear at the bottom of every page.",
      "bildausschnitt": "Below an image in a section you can now choose its focus: the chosen part stays visible when the image is cropped on phones.",
      "seiten-vorlagen-kopie": "New pages can start from a template such as services, prices or about us, pages built from sections can be copied, and the check before publishing lists empty page titles and descriptions for search engines.",
      "symbole-ankuendigung": "Benefits and services can now carry an icon from a fixed set, and in the fields for all pages you can add an announcement that appears at the very top of every page.",
      "zuruecknehmen-cloudflare": "The last publication can now always be rolled back, including websites at Cloudflare: “Publish to live” opens even when there is nothing new to publish.",
      "ki-bilder": "New “AI image” tab in the image window: describe what the image should show and get a matching photo; Claude can create images this way too.",
      "baustein-logos": "New block Logos: partners, certificates or awards as a row or in tiles, in one colour or in their original colours.",
      "seite-ohne-suche": "A page’s menu now has “Hide from search engines”: the page stays on the website, but Google leaves it out, for example a thank-you page.",
      "kontaktseite-bausteine": "New websites get a contact page made of blocks: intro, form beside phone and email, directions with a map. It can be rearranged like any other page.",
      "logo-hell-branche": "Under “For all pages” there is now a light logo for dark styles, the business type for Google and whether the hours are opening hours. Google then shows them.",
      "mit-claude-uebersetzen": "On a multilingual website, each page’s menu now has “Translate with Claude”: Claude fills every other language in the preview.",
      "bewegung-parallaxe": "Under Design you now choose how sections appear on scroll and whether large images move with the page. Visitors who prefer reduced motion see none.",
      "kopf-einblendend": "The header can now hide while reading and come back when scrolling up, with a light shadow. Set it under Design, header on scroll.",
      "schrift-paare": "Design now offers font pairings: a heading and body font that look good together, in one click.",
      "neue-darstellungen": "New layouts: gallery as a strip or slideshow, testimonials as a carousel or one large quote, prices as packages with one highlighted offer.",
      "fuss-varianten": "The footer now comes in three layouts: two columns, columns with headings and simple centred. Set it under Design.",
      "kopf-varianten": "The header can now show logo and menu centred, and on phones the menu can open full screen.",
      "baustein-speisekarte": "New block Menu: dishes by category, with price and labels like vegan or spicy, in euro or baht.",
      "baustein-zimmer": "New block Rooms: photo, size, guests, price and amenities, with a booking button, as cards or large alternating.",
      "baustein-vorher-nachher": "New block Before/after: two photos on top of each other, a slider shows the difference.",
      "bild-look": "Under Design you choose a photo look for all images, such as warm or soft, so your own photos, stock photos and AI images look consistent. Logos stay unchanged.",
      "schwebeknopf-laufband": "New: a floating button at the bottom right for WhatsApp, LINE or phone, logos as a moving strip, and cuisine and price level for Google. All under “For all pages” and in the sections.",
      "abschnitt-geraet": "Each section menu now has “Visible on”: all devices, phones only, or tablet and up only.",
      "formular-zusatzfelder": "The contact form can now also ask for phone, preferred date and number of people, each off, optional or required.",
      "untermenue": "In the menu window a page can now be indented under the page above. On the website it then appears as a submenu.",
      "bewegung-tempo": "Under Design you now set the speed of the scroll animation, from calm to lively. In each section menu you can choose a motion for that section or turn it off.",
      "branchenpaket": "Under “New website” you now choose an industry. The website then starts with a matching style, a structured home page and two or three pages, such as Massages, Gift vouchers and About us.",
      "formular-ohne-haekchen": "The contact form of new websites no longer has a consent tick box. Below it is a short note with a link to the privacy policy, which you can edit in the section.",
      "anfragen-im-panel": "Enquiries from the contact form now also appear in the CMS, under “Enquiries” at the top: read, reply by email, delete. The CMS deletes them automatically after six months.",
      "landingpage": "The page menu now has “As landing page”: only logo and button at the top, no menu. Good for ad and offer pages.",
      "faq-aufklappen": "In the “FAQ” section you can now choose whether the first question is open and whether only one opens at a time. Choices in sections now also apply in every language of the page.",
      "kleine-reste-vorlage": "New in the template: phone and social links at the bottom of the phone menu, image width and image above the text on phones for “Text with image”, and a second price per dish in the menu, such as small and large.",
      "menue-links": "Own links in the menu: under “For all pages” you enter up to four links with name and target, for example to online booking or to a spot like “/#prices”. In the “Menu” window you place them in header or footer like pages.",
      "hero-video": "The hero with image can now show a short video instead of the still image. It has a pause button and does not load with reduced motion or data saving.",
      "markenprofil": "New in the chat: a brand profile Claude gets with every request. Every text field has “Shorter”, “Friendlier” and “Another version”, and before publishing there is “Let Claude check first”.",
      "neuigkeiten-blog": "News and blog: a page from the “Post” template gets a date and appears in the new “News” section; the “News” template shows all of them. Plus the “Text” block for long articles with subheadings.",
      "sprachen-ergaenzen": "New in the top bar: “Languages”. A website gets another language there, Claude translates all of it on request, and it goes live only after “Release”."
    }
  },
  "nav": {
    "audit": "Audit log",
    "projects": "Projects",
    "settings": "Settings",
    "logout": "Sign out",
    "konto": "Account",
    "projekt": "Project",
    "bearbeiten": "Edit",
    "kataloge": "Catalogues",
    "farben": "Colours",
    "nicht_gefunden": "Not found",
    "editor": "Editor"
  },
  "projects": {
    "title": "All projects",
    "subtitle": "{n} customer site. Open it to edit. | {n} customer sites. Pick one to edit.",
    "search": "Search…",
    "empty": "No projects yet. Create a customer site with app.json.",
    "open": "Open",
    "schema_ok": "Schema OK",
    "schema_missing": "No schema",
    "sites": "Sites",
    "default_lang": "Language"
  },
  "project_detail": {
    "back": "← Back",
    "site": "Site",
    "lang": "Language",
    "fields_count": "{n} field | {n} fields",
    "loading": "Loading…",
    "synchron": "Staging and live are in sync",
    "seit_live": "{n} change since live | {n} changes since live",
    "eintraege_verwalten": "Manage {n} entry yourself → | Manage {n} entries yourself →",
    "farben_aendern": "Change {n} brand colour → | Change {n} brand colours →",
    "schema_status": "Schema status: {status}",
    "schema_fehlt": "✗ missing",
    "schema_vorhanden": "✓ ok"
  },
  "login": {
    "title": "Sign in",
    "laeuft": "Signing in …",
    "bitte_anmelden": "Please sign in",
    "bestaetigen": "Confirm",
    "prueft": "Checking …",
    "recovery_hinweis": "No access to the app? Enter a recovery code instead, for example {beispiel}.",
    "fehler": {
      "invalid_credentials": "Username or password is incorrect.",
      "missing_credentials": "Please enter your username and password.",
      "invalid_code": "That code is not correct. Please try again.",
      "invalid_token": "The sign-in has expired. Please start again.",
      "rate_limited": "Too many attempts. Please wait {n} minute. | Too many attempts. Please wait {n} minutes.",
      "unbekannt": "Sign-in did not work ({grund})."
    }
  },
  "errors": {
    "load_failed": "Load failed",
    "save_failed": "Save failed",
    "network": "Network error"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "retry": "Retry"
  },
  "publish": {
    "titel": "Publish to live",
    "ziel": "All changes from miraCMS go to the website.",
    "laedt": "Loading changes …",
    "nichtsTitel": "Nothing to publish",
    "nichtsText": "The website already shows the latest version.",
    "aenderungen": "{n} change will be published. | {n} changes will be published.",
    "seiten": "Affects {n} page. | Affects {n} pages.",
    "abbrechen": "Cancel",
    "jetzt": "Publish now",
    "laeuft": "Publishing …",
    "erfolg": "Published. The changes are now on the website.",
    "einzelheiten": "Technical details",
    "hinweisGespeichert": "Something was saved while publishing was running. That part is not out yet. Please publish once more.",
    "fehler": {
      "titel": "Not published",
      "nichts": "There is nothing to publish. The website already shows the latest version.",
      "beschaeftigt": "Someone is already publishing right now. Please wait a moment and try again.",
      "pruefungFehlt": "The server could not reach the place where the texts are stored. Nothing was published. Please try again in a few minutes.",
      "livevoraus": "The website contains changes that did not come from miraCMS. Nothing was published. Please contact miraTEQ.",
      "bauFehler": "The website could not be rebuilt. Nothing was published, the old version is still online. Please contact miraTEQ.",
      "ungesichert": "There is unsaved work on the server. Nothing was published. Please contact miraTEQ.",
      "sicherung": "No backup copy could be made before publishing. Nothing was published. Please contact miraTEQ.",
      "freigabe": "The website is updated, but a technical note could not be saved. Please contact miraTEQ.",
      "unbekannt": "Something went wrong while publishing. Nothing was published. Please contact miraTEQ.",
      "cloudflareZugang": "Nothing was published, the website is unchanged. The access to its place at Cloudflare is missing. Please contact miraTEQ.",
      "cloudflareLesen": "Nothing was published, the website is unchanged. Cloudflare did not report which version is running, and without that it could not be rolled back later. Please try again in a few minutes.",
      "hochladen": "Nothing was published, the website is unchanged. The upload to Cloudflare did not work. Please contact miraTEQ.",
      "baubefehlAlt": "Nothing was published. The settings of this project are out of date. Please contact miraTEQ."
    },
    "zurueck": {
      "knopf": "Undo last publish",
      "stand": "The website will show the version from {zeit} again.",
      "hinweis": "Your texts in miraCMS stay as they are.",
      "laeuft": "Undoing …",
      "erfolg": "The website shows the previous version again.",
      "teilweise": "The website shows the previous version again. A technical note could not be reset, please contact miraTEQ.",
      "fehler": {
        "titel": "Not undone",
        "nichtMoeglich": "There is no backup copy to undo for this project.",
        "keine": "There is nothing to undo yet.",
        "veraltet": "Something else was published since then. This version can no longer be restored.",
        "unbekannt": "Undoing did not work. Please contact miraTEQ.",
        "umschalten": "The website still shows the new version. Cloudflare refused to switch back. Please contact miraTEQ.",
        "cloudflareLesen": "Nothing was rolled back. Cloudflare did not report which version is running. Please try again in a few minutes."
      }
    },
    "erster_livegang_fehlt": "Still missing for the first go-live:",
    "in_einrichtung": "You can do this under “Setup” in the top bar.",
    "erster_livegang_laeuft": "The website is uploaded and is now being connected to its domain.",
    "rauchtest_zurueck": "The website did not respond correctly after the upload. miraCMS switched back to the previous version, visitors see the old state.",
    "rauchtest_fehler": "The website did not respond correctly after the upload, and the previous version could not be switched back on. Please let miraTEQ know immediately."
  },
  "vorab": {
    "alle_seiten": "On all pages",
    "muss_titel": "Fix before publishing: {n} item | Fix before publishing: {n} items",
    "muss_hinweis": "These are still placeholders from the template. Click one to go to the field.",
    "weitere": "Show {n} more | Show {n} more",
    "soll_titel": "{n} recommendation | {n} recommendations",
    "alles_gut": "Checked: no placeholders, all images described, headings in order.",
    "gekuerzt": "{n} more findings are not listed here.",
    "gesperrt": "Replace the placeholders first",
    "art": {
      "platzhalter": "{seite}: “{feld}” is still a placeholder",
      "platzhalter_bild": "{seite}: the image “{feld}” is still the placeholder image",
      "bild_ohne_beschreibung": "{seite}: “{feld}” is empty, the image has no description",
      "beschreibung_pruefen": "{seite}: check the image description after the image was replaced",
      "h1_fehlt": "{seite} has no main heading",
      "h1_mehrfach": "{seite} has {n} main headings instead of one | {seite} has {n} main headings instead of one",
      "ueberschrift_sprung": "{seite}: a heading level is skipped | {seite}: a heading level is skipped {n} times",
      "bild_ohne_alt": "{seite}: an image in the page layout has no description, miraTEQ fixes this | {seite}: {n} images in the page layout have no description, miraTEQ fixes this",
      "link_ohne_text": "{seite}: a link has no readable name, miraTEQ fixes this | {seite}: {n} links have no readable name, miraTEQ fixes this",
      "pflicht_fehlt": "{seite}: “{feld}” is empty, it is a required detail",
      "seo_titel_fehlt": "{seite}: The page title for search engines is empty",
      "seo_beschreibung_fehlt": "{seite}: The description for search engines is empty"
    }
  },
  "kopf": {
    "suchen": "Search",
    "suchen_titel": "Search (Cmd+K)",
    "bereich": "Choose area"
  },
  "projekt": {
    "vorschau_link": "Preview link",
    "vorschau_link_hinweis": "View only, expires",
    "zugriff": "Access",
    "zugriff_hinweis": "Who may open this project",
    "verlauf": "History",
    "verlauf_hinweis": "Who changed what, and when",
    "kataloge": "Catalogues",
    "auf_live": "Publish",
    "auf_live_nichts": "Preview and live are identical, nothing to publish. The last publication can be rolled back here.",
    "auf_live_zaehler": "{n} change since live | {n} changes since live",
    "mehr": "What does not fit here right now"
  },
  "seite": {
    "entwurf": "Draft",
    "sichtbar": "Visible",
    "entwurf_marke": "Draft, make it visible",
    "sichtbar_marke": "Visible, move back to draft",
    "sichtbar_machen": "Make visible",
    "sichtbar_machen_hinweis": "Goes onto the website with the next publish",
    "zurueck_entwurf": "Back to draft",
    "zurueck_entwurf_hinweis": "Disappears from the website with the next publish",
    "diese_seite": "This page",
    "gespeichert": "Saved",
    "gespeichert_vor": "Saved {min} min ago",
    "baue_vorschau": "Building preview …",
    "sprache": "Language",
    "vorschau": "Preview",
    "vorschau_groesse": "Preview size",
    "desktop": "Desktop",
    "tablet": "Tablet",
    "handy": "Phone",
    "desktop_hinweis": "As wide as the space allows",
    "breite_hinweis": "{px} px wide",
    "desktop_titel": "Desktop, as wide as the space allows",
    "tablet_titel": "Tablet, 768 px wide",
    "handy_titel": "Phone, 390 px wide",
    "neu_laden": "Reload preview",
    "kommentare": "Comments",
    "kommentare_offen": "Comments, {n} open",
    "speichern": "Save",
    "speichere": "Saving…",
    "speichern_titel": "{n} unsaved change, save now (Cmd+S) | {n} unsaved changes, save now (Cmd+S)",
    "panel_links": "Show or hide pages and fields",
    "panel_rechts": "Show or hide the edit panel",
    "feld_bearbeiten": "Edit field",
    "was": "This page",
    "fehler": {
      "ohne_ueberschrift": "A page needs a heading.",
      "keine_adresse": "No web address can be made from this heading. Please use letters or numbers.",
      "sprache_gibt_es_schon": "This page already exists in {sprache}.",
      "sprache_unbekannt": "This template does not support the language {sprache}.",
      "seite_unbekannt": "This page is no longer in the list. Please reload.",
      "vorlage_unbekannt": "This project does not know this template.",
      "nur_entwurf": "This page is live on the website. Set it back to draft first, then it can be deleted."
    },
    "verlassen_frage": "You have {n} unsaved change. Leave without saving? | You have {n} unsaved changes. Leave without saving?",
    "loeschen_frage": "Delete “{name}”?\n\nThe page disappears with all its texts and languages. Only miraTEQ can undo this.",
    "geloescht": "“{name}” was deleted",
    "suche_aus": "Hide from search engines",
    "suche_aus_hinweis": "Stays on the website, Google and others leave it out",
    "suche_an": "Show in search engines again",
    "suche_an_hinweis": "Google and others may list the page again",
    "ohne_suche_marke": "Hidden from search engines",
    "uebersetzen": "Translate with Claude",
    "uebersetzen_hinweis": "Claude fills every other language of this page in the preview",
    "landing_an": "As landing page: header without menu",
    "landing_an_hinweis": "For ad and offer pages: only logo and button at the top, so visitors stay on the one thing.",
    "landing_aus": "Show the menu in the header again",
    "landing_aus_hinweis": "The page shows the website menu at the top again.",
    "beitrag_an": "As post dated today",
    "beitrag_an_hinweis": "The page appears with date, image and description in the “News” section.",
    "beitrag_aus": "No longer a post",
    "beitrag_aus_hinweis": "Post dated {datum}. Afterwards it is a normal page again, without date and no longer in the news."
  },
  "liste": {
    "seiten": "Pages",
    "felder": "Fields",
    "seiten_des_projekts": "Pages of this project",
    "neuer": "New {was}",
    "entwurf_punkt": "Draft, not on the website yet",
    "zeilenmenue": "What to do with “{name}”",
    "loeschen": "Delete {was}",
    "loeschen_hinweis": "Permanent, including all its texts",
    "seite": "page",
    "startseite": "Home",
    "alle_seiten": "All pages",
    "weitere": "Other",
    "geteilt": "Shared",
    "geteilt_hinweis": "Texts that appear on several pages",
    "filtern": "Filter …",
    "nichts_gefunden": "Nothing found.",
    "anlegen": "Create",
    "wird_angelegt": "Creating …",
    "abschnitte": "Sections",
    "ungespeichert_punkt": "Unsaved changes"
  },
  "suche": {
    "titel": "Search and do",
    "platzhalter": "Page, field, project or action …",
    "nichts": "Nothing found.",
    "auswaehlen": "select",
    "ausfuehren": "run",
    "gruppe_seiten": "Pages",
    "gruppe_felder": "Fields on this page",
    "gruppe_projekte": "Projects",
    "gruppe_handgriffe": "Actions",
    "vorschau_link_erstellen": "Create preview link",
    "auf_live_veroeffentlichen": "Publish to live",
    "aenderungen": "{n} change | {n} changes",
    "nichts_neues": "nothing new"
  },
  "konto": {
    "sprache": "Interface language",
    "sprache_hinweis": "Applies to the CMS only, not to the website",
    "deutsch": "Deutsch",
    "englisch": "English",
    "name": "Name",
    "hell": "Light",
    "dunkel": "Dark",
    "modus_dunkel": "Dark mode (click for light)",
    "modus_hell": "Light mode (click for dark)",
    "passwort_verbergen": "Hide password",
    "passwort_anzeigen": "Show password",
    "verbergen": "🙈 Hide",
    "anzeigen": "👁 Show",
    "speichert": "Saving …",
    "weiter": "Continue",
    "kopiert": "✓ Copied",
    "kopieren": "Copy",
    "wird_aktiviert": "Turning on …",
    "zwei_fa_aktivieren": "Turn on 2FA",
    "wird_deaktiviert": "Turning off …",
    "zwei_fa_deaktivieren": "Turn off 2FA",
    "code_eingeben": "Please enter the six-digit code.",
    "zwei_fa_an": "2FA is on. You will be asked for the code at your next sign-in.",
    "zwei_fa_aus": "2FA turned off",
    "kopieren_fehler": "Copying did not work. Please write the codes down by hand.",
    "codes_datei_titel": "miraCMS recovery codes for {name}",
    "codes_datei_erstellt": "Created: {datum}",
    "codes_datei_einmal": "Each code works only ONCE. Use one if your phone is lost.",
    "codes_datei_aufbewahren": "Keep them safe (password manager or printed).",
    "passwort_geaendert": "Password changed",
    "fehler": {
      "sitzung": "Your session has expired. Please sign out and sign in again.",
      "passwort_falsch": "The password is incorrect.",
      "passwort_kurz": "The new password needs at least 15 characters, or 12 with two-factor protection.",
      "passwort_kurz_fremd": "The new password needs at least 15 characters.",
      "erst_einrichten": "Please set up 2FA first."
    }
  },
  "menue": {
    "weitere": "More actions"
  },
  "ui": {
    "hauptnavigation": "Main navigation",
    "verlauf": "History",
    "lade_verlauf": "Loading history…",
    "keine_aenderungen_an_dieser_page_gefunden": "No changes found for this page.",
    "neu_laden": "Reload",
    "lade_diff": "Loading diff …",
    "keine_textlichen_aenderungen_in_dieser_datei": "No text changes in this file (only its metadata was touched).",
    "aenderungsverlauf": "Change history",
    "schliessen": "Close",
    "konto_amp_sicherheit": "Account & security",
    "abmelden": "Sign out",
    "fuer_dieses_konto_ist_zwei_faktor_schutz_erf": "This account requires two-factor protection.",
    "jetzt_einrichten": "Set it up now",
    "menue_schliessen": "Close menu",
    "bereitgestellt_von": "Provided by",
    "vorschau_wird_noch_gebaut": "Preview is still building",
    "keine_eigene_seite": "No page of its own",
    "zurueck": "Back",
    "preview_nicht_verfuegbar": "Preview not available",
    "erneut_versuchen": "Try again",
    "customer_site_live_preview": "Live preview of the customer site",
    "uebersicht_ausblenden": "Hide the overview",
    "vorschau_im_zusammenhang": "Preview in context",
    "hoehe_der_uebersicht": "Height of the overview",
    "vorschau_link_erstellen": "Create preview link",
    "keine_staging_url_konfiguriert": "(no staging URL configured)",
    "magic_link_klick_zum_kopieren": "Magic link (click to copy)",
    "in_zwischenablage_kopiert_jetzt_in_whatsapp": "✓ Copied to the clipboard. Now paste it into WhatsApp, mail or wherever you like.",
    "anderen_link_generieren": "← Generate another link",
    "customer_vorschau_link_generieren": "Generate a preview link for the customer",
    "benachrichtigungen": "Notifications",
    "ansicht_wechseln": "Change view",
    "kachel_ansicht": "Card view",
    "listen_ansicht": "List view",
    "zugriff": "Access",
    "zugaenge": "Logins",
    "anlegen": "+ Add",
    "passwort": "Password",
    "entfernen": "Remove",
    "setzen": "Set",
    "abbrechen": "Cancel",
    "noch_kein_zugang": "No login yet.",
    "anlegen_2": "Add",
    "nur_jetzt_sichtbar": "Shown this once only.",
    "link_ohne_anmeldung": "Link without sign-in",
    "link_erzeugen": "Create link",
    "neuer_link": "New link",
    "einen_moment": "One moment …",
    "zwei_faktor_schutz_ist_eingeschaltet": "Two-factor protection is on",
    "neues_passwort": "New password",
    "benutzername": "Username",
    "adresse_des_links": "Address of the link",
    "der_bisherige_link_gilt_danach_nicht_mehr": "The previous link stops working after this",
    "ansehen": "View",
    "durch_die_seite_klicken_wie_ein_besucher": "Click through the site like a visitor",
    "kommentieren": "Comment",
    "kommentare_an_stellen_heften": "Pin comments to spots on the page",
    "durch_die_seite_klicken": "Click through the site",
    "texte_aendern": "Edit texts",
    "selbst_am_text_arbeiten_und_speichern": "Work on the text and save it",
    "selbst_veroeffentlichen": "Publish",
    "auf_die_echte_website_stellen_ohne_uns": "Put it on the real website without us",
    "breite_des_feld_editors": "Width of the field editor",
    "alle_kommentare": "← All comments",
    "die_stelle_gibt_es_auf_dieser_seite_nicht_me": "That spot no longer exists on this page. The comment stays, but it has no pin.",
    "der_kommentar_bleibt_offen_zum_abschliessen": "The comment stays open. To close it, use “Done” below.",
    "zustand": "Status",
    "sichtbar_fuer": "Visible to",
    "erledigt": "Done",
    "wieder_oeffnen": "Reopen",
    "loeschen": "Delete",
    "bild_oder_pdf_anhaengen_geht_auch_mit_ziehen": "Attach an image or PDF, dragging and pasting works too",
    "antworten": "Reply …",
    "alle": "All",
    "laedt": "Loading …",
    "ohne_nadel": "no pin",
    "die_stelle_gibt_es_auf_dieser_seite_nicht_me_2": "That spot no longer exists on this page",
    "klebt_auf_einer_anderen_seite_ein_klick_wech": "Sits on another page. One click takes you there.",
    "kommentar_an_dieser_stelle": "Comment on this spot",
    "eine_stelle_ohne_eigenen_text": "A spot without a text of its own",
    "datei": "File",
    "art": "Kind",
    "was_soll_hier_anders_werden": "What should be different here?",
    "ueberschrift": "Heading",
    "sprache": "Language",
    "die_zweite_sprache_kann_spaeter_dazukommen": "The second language can follow later.",
    "adresse": "Address",
    "bleibt_so_auch_wenn_die_ueberschrift_sich_sp": "Stays as it is, even if the heading changes later.",
    "startet_als_entwurf_auf_der_website_erschein": "Starts as a draft. It only appears on the website once you make it visible.",
    "was_ein_klick_in_die_vorschau_tut": "What a click in the preview does",
    "schritt": "Step",
    "diese_seite_hat_animationen_waehle_einen_sch": "This page has animations. Pick a step to see and edit the text that appears there.",
    "waehle_links_ein_feld_zum_editieren": "Pick a field on the left to edit it.",
    "dieser_text_wird_geteilt_und_erscheint_auf_m": "This text is shared and appears on several pages. The change applies everywhere.",
    "auch_hier": "Also here",
    "andere_sprachen": "Other languages",
    "zuruecksetzen": "Reset",
    "ungespeicherte_aenderung": "unsaved change",
    "noch_offen": "Still open",
    "gepinnt": "Pinned",
    "erscheint_auf_mehreren_seiten": "(appears on several pages)",
    "keine_felder_gefunden": "No fields found.",
    "speichern": "saving…",
    "gespeichert": "saved",
    "felder_filtern": "Filter fields…",
    "felder_filtern_2": "Filter fields",
    "account": "Account",
    "username": "Username",
    "rolle": "Role",
    "projekte": "Projects",
    "darstellung": "Appearance",
    "theme": "Theme",
    "passwort_aendern": "Change password",
    "aktuelles_passwort": "Current password",
    "neues_passwort_min_8_zeichen": "New password (at least 15 characters, 12 with two-factor protection)",
    "wiederholen_zur_sicherheit": "Repeat it (to be sure)",
    "passwoerter_stimmen_nicht_ueberein": "The passwords do not match",
    "zwei_faktor_authentifizierung_2fa": "Two-factor authentication (2FA)",
    "2fa_ist_aktiviert": "2FA is on",
    "beim_login_fragt_miracms_einen_6_stelligen_c": "At sign-in miraCMS asks for a six-digit code from your authenticator app.",
    "deaktivieren": "Turn off",
    "2fa_ist_nicht_aktiv": "2FA is off",
    "empfohlen_schuetzt_deinen_account_auch_wenn": "Recommended, it protects your account even if the password leaks.",
    "einrichten": "Set up",
    "bestaetige_dein_aktuelles_passwort_dann_zeig": "Confirm your current password and miraCMS shows the QR code for your authenticator app.",
    "schritt_1": "Step 1:",
    "app_kann_nicht_scannen_tippe_das_secret_manu": "App cannot scan? Type the secret in by hand:",
    "schritt_2": "Step 2:",
    "als_txt_herunterladen": "Download as .txt",
    "schritt_3": "Step 3:",
    "bestaetige_den_ersten_code_aus_der_app": "Confirm the first code from the app.",
    "6_stelliger_code_aus_app": "Six-digit code from the app",
    "2fa_wird_deaktiviert_dein_account_ist_dann_n": "2FA will be turned off. Your account is then protected by the password alone. Confirm your password.",
    "sitzung": "Session",
    "aktuelle_sitzung_beenden_und_zum_login_wechs": "End this session and go back to sign-in.",
    "2fa_qr_code": "2FA QR code",
    "vorschau_seite": "Preview page",
    "wird_geladen": "Loading …",
    "ansehen_2": "View ↗",
    "geaendert": "changed",
    "zuruecksetzen_2": "reset",
    "auf_allen_vier_seiten": "On all four pages",
    "alles_auf_standard_ein_leeres_feld_setzt_zur": "Everything at its default. An empty field resets it.",
    "der_haeufigste_fall_jemand_ruft_die_adresse": "The most common case: someone opens the address without their personal link.",
    "der_link_war_einmal_gueltig_ist_es_nach_30_t": "The link was valid once, but not any more after 30 days.",
    "seltener_fehlerfall_auf_dem_server_sollte_ni": "A rare server error. Nobody should ever see it.",
    "der_link_zeigt_auf_eine_unterseite_die_es_ni": "The link points to a page that does not exist.",
    "kleintext_unten": "Small print at the bottom",
    "steht_unter_der_karte_auf_jeder_der_vier_sei": "Sits below the card, on each of the four pages.",
    "betreff_der_mail": "Subject of the mail",
    "die_adresse_der_vorschau_wird_hinten_angehae": "The preview address is appended to it.",
    "kundenzugaenge": "Customer logins",
    "name_display": "Name (display)",
    "passwort_neuer_benutzer": "Password (at least 15 characters)",
    "admin_alle_projekte_user_verwaltung": "admin (all projects + user management)",
    "editor_alle_projekte_keine_user_verwaltung": "editor (all projects, no user management)",
    "lade_benutzer": "Loading users …",
    "alle_projekte": "· all projects",
    "kein_projekt_zugewiesen": "· no project assigned",
    "bearbeiten": "Edit",
    "sieht_automatisch_alle_projekte_keine_auswah": "Sees every project automatically, nothing to pick.",
    "keine_projekte_konfiguriert": "No projects configured.",
    "passwort_zuruecksetzen": "Reset password",
    "ersetzen": "Replace",
    "laedt_hoch": "Uploading …",
    "wird_auf_cdn_mirateq_com_gespeichert": "Stored on cdn.mirateq.com",
    "bild_ersetzen": "Replace image",
    "jpg_png_gif_oder_webp_wird_automatisch_optim": "JPG, PNG, GIF or WebP, optimised automatically",
    "link_weg": "Unlink",
    "fett_b": "Bold (⌘B)",
    "kursiv_i": "Italic (⌘I)",
    "ausgewaehlten_text_zu_einem_link_machen": "Turn the selected text into a link",
    "link_entfernen": "Remove the link",
    "liste": "• List",
    "1_liste": "1. List",
    "umbruch": "↵ Break",
    "ohne_format_einfuegen": "Paste without formatting",
    "zwischenueberschrift": "Subheading",
    "aufzaehlung_mit_punkten": "Bulleted list",
    "aufzaehlung_mit_zahlen": "Numbered list",
    "zeilenumbruch_an_der_cursorstelle": "Line break at the cursor",
    "aus_der_zwischenablage_einfuegen_ohne_format": "Paste from the clipboard without formatting",
    "bitte_waehlen": "Please choose …",
    "zurueck_2": "← Back",
    "projekt": "← Project",
    "veroeffentlicht": "Publishing …",
    "website_aktuell": "Website is up to date",
    "veroeffentlichen": "Publish",
    "neuer_eintrag": "+ New entry",
    "speichert": "Saving …",
    "suche_aktiv_sortieren_pausiert": "Search is on, sorting is paused.",
    "noch_nicht_veroeffentlicht": "Not published yet",
    "hier_bleiben": "Stay here",
    "spaeter_veroeffentlichen": "Publish later",
    "jetzt_veroeffentlichen_amp_gehen": "Publish now & leave",
    "diesen_eintrag_wirklich_loeschen": "Really delete this entry?",
    "suchen": "Search …",
    "liste_2": "List",
    "kacheln": "Cards",
    "ziehen_zum_sortieren": "Drag to sort",
    "ziehen": "Drag",
    "umbenennen": "Rename",
    "ihre_kommentare_zur_website": "Your comments on the website",
    "bitte_melden_sie_sich_bei_uns_dann_schicken": "Please get in touch and we will send you a new one.",
    "klicken_sie_auf_eine_stelle_in_der_seite_um": "Click a spot on the page to leave a comment.",
    "sie_sehen_die_seite_wie_ein_besucher_zum_anm": "You see the page as a visitor does. To add a note, use the speech bubble above.",
    "ihre_kommentare": "Your comments",
    "zwei_faktor_code": "Two-factor code",
    "oeffne_deine_authenticator_app_und_tippe_den": "Open your authenticator app and type in the six-digit code.",
    "code": "Code",
    "z_b_admin": "e.g. admin",
    "seite_nicht_gefunden": "Page not found",
    "vorschau_link": "Preview link",
    "auf_live_veroeffentlichen": "Publish to live",
    "design_farben": "Design · Colours",
    "projekt_laedt": "Loading the project…",
    "live_preview": "Live preview",
    "einstellungen": "Settings",
    "account_amp_benutzer_verwaltung": "Account & user management",
    "benutzer": "Users",
    "lesbarkeit_wcag_kontrast": "Readability (WCAG contrast)",
    "ziel_aa_4_5_fuer_normalen_text_hinweis_kein": "Target: AA (≥ 4.5) for normal text. A hint, not a rule.",
    "live_vorschau": "Live preview",
    "auf_gespeicherten_wert_zuruecksetzen": "Reset to the saved value",
    "live_vorschau_farben": "Live preview of the colours",
    "diese_seite_ist_gerade_nicht_als_vorschau_vo": "This page has no preview right now. After the next save the server builds it again, which takes a moment. You can edit its texts in the field list straight away.",
    "diese_texte_erscheinen_auf_mehreren_seiten_z": "These texts appear on several pages (prices, navigation or footer, for example). You can edit them in the field list as usual, and they are updated everywhere they appear.",
    "link_generieren_kopieren_und_per_whatsapp_si": "Create the link, copy it and send it to the customer via WhatsApp, Signal, Line or mail. Valid for 30 days.",
    "per_whatsapp_signal_line_mail_an_den_kunden": "Send it to the customer via WhatsApp, Signal, Line or mail. Opening the link sets a 30-day cookie and the customer can look at the preview.",
    "scanne_diesen_qr_code_mit_deiner_authenticat": "Scan this QR code with your authenticator app (Google Authenticator, 1Password, Authy or the iCloud keychain, for example).",
    "sichere_diese_recovery_codes_sie_helfen_wenn": "Keep these recovery codes safe. They help if the phone is lost. Each code works only ONCE.",
    "diese_seite_sieht_eine_kundin_wenn_sie_eine": "This is what a customer sees when they open a preview without a valid link. It appears in the language of the website in question. A change here takes effect on every preview address at once, with no deploy.",
    "sieht_automatisch_alle_projekte_keine_auswah_2": "Sees every project automatically, nothing to pick. A login for a customer is created inside the project, under “Access”.",
    "link_unvollstaendig": "This link is incomplete.",
    "link_gilt_nicht_mehr": "This link is no longer valid.",
    "zu_viele_versuche": "Too many attempts from here. Please try again in fifteen minutes.",
    "gleich_wieder_da": "Please reload the page then.",
    "original": "Original",
    "auf_die_ausgelieferte_markenfarbe_zuruecksetzen": "Reset to the original brand colour",
    "alle_auf_original": "All to original",
    "alle_farben_auf_die_ausgelieferten_werte": "Reset all colours to the original brand values",
    "nur_ansehen": "View only: changing texts is not enabled for this account.",
    "katalog_pflegen": "Manage catalog",
    "katalog_pflegen_hinweis": "Add, change and publish catalog entries"
  },
  "meldung": {
    "ansehen": "View",
    "ansehen_hinweis": "Click through the page like a visitor",
    "kommentieren": "Comment",
    "kommentieren_hinweis": "Pin a comment to a spot",
    "bearbeiten": "Edit",
    "bearbeiten_hinweis": "Click a text and change it",
    "speichern_abgelehnt": "Save refused",
    "unbekannter_fehler": "Unknown error",
    "nicht_in_versionsgeschichte": "The change is on the server, but it was not added to the version history.",
    "erst_speichern": "Save first",
    "ungespeicherte_auf_dieser_seite": "There are unsaved changes on this page.",
    "hier_nicht_moeglich": "That is not possible here.",
    "kommentar_weg": "This comment no longer exists.",
    "sitzung_abgelaufen": "The session has expired. Please reload the page.",
    "server_stumm": "The server did not answer. Please try again.",
    "nicht_geklappt": "That did not work. Please try again.",
    "eingabe_abgelehnt": "The server did not accept the input.",
    "server_abgebrochen": "The server gave up: {dazu}",
    "gibt_es_nicht_mehr": "{was} no longer exists.",
    "zu_viele_kommentare": "Too many comments in a short time. You can continue in {minuten} minutes.",
    "zu_viele_kommentare_gleich": "Too many comments in a short time. You can continue shortly.",
    "zu_viele_kommentare_eine": "Too many comments in a short time. You can continue in a minute.",
    "nicht_gespeichert": "Not saved",
    "kein_bearbeiten_recht": "Changing texts is not enabled for this account.",
    "was_das": "That",
    "keine_berechtigung": "You do not have permission for this.",
    "inzwischen_geaendert": "{was} has changed in the meantime. Please reload.",
    "zu_viele_aenderungen": "A lot of changes arrived in a short time. Please wait a minute and then try again.",
    "ging_nicht": "That did not work",
    "keine_texte": "No texts found",
    "bereich_kaputt": "A text section is damaged: {name}",
    "bereiche_kaputt": "{n} text section is damaged | {n} text sections are damaged",
    "bereich_kaputt_text": "Everything else can be edited as usual. Please let miraTEQ know.",
    "nicht_bei_github": "The change is on the server but not on GitHub yet.",
    "gespeichert_ungesichert": "Saved, but not backed up",
    "absatz": {
      "eingefuegt": "Paragraph inserted",
      "hoch": "Paragraph moved up",
      "runter": "Paragraph moved down",
      "geloescht": "Paragraph deleted",
      "geaendert": "Changed"
    },
    "vorschau_aktuell": "The preview is updated.",
    "vorschau_nicht_aktuell": "Preview not up to date yet",
    "anderer_bau": "Another build is running. Please reload in a moment.",
    "text_bricht_vorschau": "This text breaks the preview",
    "vorschau_bau_fehler": "The preview could not be rebuilt",
    "vorschau_anstossen_fehler": "Could not start the preview build",
    "vorschau_dauert": "The preview is taking unusually long",
    "vorschau_dauert_text": "The text is saved. The preview is still being built.",
    "pruefung": {
      "titel": "Invalid input",
      "mehrere": "Several fields are invalid.",
      "zu_lang": "At most {max} characters allowed (entered: {laenge}).",
      "zu_lang_kurz": "Text too long.",
      "zu_kurz": "At least {min} characters required (entered: {laenge}).",
      "zu_kurz_kurz": "Text too short.",
      "pflicht": "Required, cannot be empty.",
      "farbe": "Please enter a colour code in the format #RRGGBB (for example #32542f).",
      "format": "Invalid format.",
      "url": "Please enter a full address (for example https://example.com).",
      "email": "Please enter a valid email address.",
      "datum": "Please enter a valid date (format: YYYY-MM-DD).",
      "typ_text": "Text is expected here.",
      "typ_zahl": "A number is expected here.",
      "typ_ja_nein": "Yes or No is expected here.",
      "typ": "Wrong type of value.",
      "unbekannt": "This field is not defined in the schema.",
      "auswahl": "Invalid value. Allowed: {erlaubt}",
      "auswahl_kurz": "Invalid value."
    }
  },
  "datei": {
    "loeschen": "Delete for good",
    "wirklich": "Delete for good?",
    "ja_loeschen": "Yes, delete",
    "geloescht": "File deleted",
    "nur_pdf": "Please choose a PDF file.",
    "hochgeladen": "PDF uploaded",
    "hochgeladen_mit_vorschau": "PDF uploaded, preview created",
    "ziehen": "Drag a PDF here, or tap to choose one",
    "noch_in_gebrauch": "The file is still used somewhere else in this project.",
    "geloescht_cache_bleibt": "File deleted. The copy in the CDN cache disappears on its own.",
    "nur_bild": "Please choose an image file (JPG, PNG, GIF, WebP).",
    "bild_hochgeladen": "Image uploaded ({kb} KB)",
    "bild_nicht_gesichert": "Image uploaded, but not backed up",
    "bild_nicht_gesichert_text": "It is on the server but not on GitHub yet. Please let miraTEQ know before you publish.",
    "bild_hochladen_fuer": "Upload image for {feld}",
    "bild_vorschau": "Preview of {feld}",
    "bild_ziehen": "Drag an image here, or tap to choose one",
    "pdf_hochladen_fuer": "Upload PDF for {feld}",
    "was": "The file",
    "fehler": {
      "kein_bild": "Only JPG, PNG, GIF or WebP files are allowed.",
      "zu_gross": "The file is too large. The limit is {mb} MB.",
      "zu_gross_kurz": "The file is too large.",
      "abgebrochen": "The upload was interrupted. Please try again.",
      "nicht_eingerichtet": "PDF uploads are not set up on this server yet. Please let miraTEQ know.",
      "verarbeitung": "The image could not be processed. Please try a different file.",
      "speicher": "The file did not reach the storage. Please try again.",
      "kein_dokument": "This address does not belong to our document storage.",
      "fremdes_dokument": "This file belongs to another project.",
      "loeschen": "The file could not be deleted. Please try again."
    }
  },
  "kommentar": {
    "adressat": {
      "intern": "Only us",
      "kunde": "The client too"
    },
    "typ": {
      "text_fix": "Change text",
      "design": "Design",
      "claude_task": "Technical change"
    },
    "status": {
      "offen": "Open",
      "in_arbeit": "In progress",
      "erledigt": "Done"
    },
    "screenshot_einfuegen": "Paste a screenshot with Cmd+V",
    "anheften": "Pin comment",
    "nadel_kunde": "Client {n}, the same pin as in the preview",
    "nadel": "Pin {n} in the preview",
    "sendet": "Sending …",
    "antworten": "Reply",
    "gruppe_kunde": "Shared with the client",
    "gruppe_intern": "Internal only",
    "leer": "No comments yet. In Comment mode, click into the preview to pin one.",
    "kein_treffer": "No comment matches this filter.",
    "antworten_anzahl": "{n} reply | {n} replies",
    "auf_seite": "on {seite}",
    "klick_schliessen": "Click to close",
    "offen_anzahl": "{n} open comment | {n} open comments",
    "ihre_website": "Your website"
  },
  "feld": {
    "bild_alle_sprachen": "The image applies to every language of the page. The image description is per language.",
    "art": {
      "text": "Text",
      "bild": "Image",
      "alt": "Image description",
      "href": "Link target",
      "src": "Image source",
      "title": "Hover title",
      "placeholder": "Field placeholder",
      "content": "Meta tag",
      "aria_label": "Screen reader label",
      "data_title": "Title"
    },
    "absatz": {
      "hoch": "↑ Move up",
      "hoch_titel": "Move this paragraph up",
      "runter": "↓ Move down",
      "runter_titel": "Move this paragraph down",
      "danach": "+ Paragraph below",
      "danach_titel": "Insert a new paragraph below",
      "loeschen": "× Delete",
      "loeschen_titel": "Delete this paragraph",
      "loeschen_frage": "Delete this paragraph?\n\n“{text}”",
      "neu": "New paragraph"
    },
    "uebersicht_ausblenden": "Hide overview",
    "ansehen_auf": "View on: {seite}",
    "max_zeichen": "max. {n} characters",
    "gruppe_sonstige": "Other",
    "gruppe_alle": "All fields",
    "pin_entfernen_fuer": "Unpin {feld}",
    "pin_umschalten_fuer": "Toggle pin for {feld}",
    "pin_entfernen": "Unpin",
    "pin_setzen": "Pin field",
    "geteilte_gruppe": "These texts appear on several pages. Changes apply everywhere.",
    "anzahl": "{n} field | {n} fields",
    "ungespeichert_anzahl": "{n} unsaved",
    "ja": "Yes",
    "nein": "No",
    "farbwaehler_fuer": "Colour picker for {feld}",
    "schritt_waehlen": "Choose step: {szene}",
    "link": "Link",
    "link_erst_auswaehlen": "First select the text that should become the link.",
    "link_ziel_frage": "Where should the link go?",
    "link_adresse": "Link address",
    "inhalt_bereinigt": "Parts of the old content were not allowed and have been removed.",
    "zwischenablage_gesperrt": "The browser does not allow access to the clipboard. ⇧⌘V also pastes without formatting.",
    "spiegel": {
      "zu_schmal": "The field is too narrow for the line breaks of this spot. Drag it wider (about {px} pixels), or switch the preview to Phone.",
      "ungefaehr": "The line breaks here only roughly match the page.",
      "an_titel": "The field breaks lines like the page. Click to turn off.",
      "aus_titel": "Break lines in the field like the page",
      "genau": "breaks like the page",
      "ungefaehr_kurz": "≈ roughly like the page",
      "aus": "like the page"
    },
    "umbruch": {
      "ausgleich": "The page spreads the lines of this heading evenly. In the field the line break only lands roughly in the same place.",
      "geschwister": "Something else sits in the same paragraph next to this text, so the last line is shorter on the page.",
      "inline_kinder": "This text contains formatting. The field shows it in one style, the page in several.",
      "lokal": "The page may use a font installed on the computer. The line breaks can then differ slightly.",
      "schrift_fehlt": "The page's font could not be loaded, so the line breaks are only approximate.",
      "erste_zeile": "The first line is set differently on the page than the rest.",
      "schrumpfbox": "This box grows with the text. After saving, the line break may fall elsewhere.",
      "faltet_umbrueche": "The page does not show line breaks from this field as breaks.",
      "grossschrift": "The page shows this text in CAPITALS."
    },
    "speichern_mit": "Save with {taste} or the save button in the bar.",
    "textfarbe": "Text colour",
    "farbe_ohne": "Colour: normal",
    "farbe_marke": "Brand colour",
    "farbe_akzent": "Accent colour",
    "farbe_gedaempft": "Muted",
    "textgroesse": "Text size",
    "groesse_normal": "Size: normal",
    "groesse_gross": "Larger",
    "groesse_klein": "Smaller",
    "hervorheben": "Highlight",
    "fokus_titel": "Image focus",
    "fokus_hinweis": "This part stays visible when the image is cropped on phones or as a wide strip.",
    "fokus": {
      "oben-links": "Top left",
      "oben": "Top",
      "oben-rechts": "Top right",
      "links": "Left",
      "mitte": "Centre",
      "rechts": "Right",
      "unten-links": "Bottom left",
      "unten": "Bottom",
      "unten-rechts": "Bottom right"
    }
  },
  "katalog": {
    "kategorie": "Category",
    "eintraege": "Entries",
    "sammlung": "Collection",
    "anzahl": "{n} entry | {n} entries",
    "alle": "All {name}",
    "ohne": "Without {name}",
    "bearbeiten": "Edit",
    "fertig": "Done",
    "bearbeiten_beenden": "Stop editing",
    "gruppe_bearbeiten": "Add, rename, sort {name}, change images",
    "bild_aendern": "Change image",
    "bild_hochladen": "Upload image",
    "ok": "OK",
    "loeschen_frage": "Delete “{name}”?",
    "umhaengen_auf": "Move {n} entry to: | Move {n} entries to:",
    "hinzufuegen": "Add {name} …",
    "ziehen_hinweis": "Drag a product onto a {name} on the left to move it",
    "ziehen_titel": "Drag to sort, or onto a {name} on the left",
    "keine_eintraege": "No entries.",
    "keine_treffer": "No entries for this search.",
    "verlassen_text": "Your changes are {gespeichert}, but not on the website yet. Do you want to publish them now?",
    "eintrag_bearbeiten": "Edit entry",
    "neuer_eintrag": "New entry",
    "speichern": "Save",
    "eintrag_angelegt": "Entry created",
    "gespeichert": "Saved",
    "geloescht": "Deleted",
    "reihenfolge_gespeichert": "Order saved",
    "kategorie_angelegt": "Category created",
    "umbenannt": "Renamed",
    "umbenannt_mit": "Renamed, {n} entry updated | Renamed, {n} entries updated",
    "kategorie_geloescht": "Category deleted",
    "geloescht_umgehaengt": "Deleted, {n} entry moved | Deleted, {n} entries moved",
    "bild_gesetzt": "Image set",
    "bild_entfernt": "Image removed",
    "alles_aktuell": "Everything is up to date",
    "veroeffentlicht_live": "Published. The website is being updated now.",
    "veroeffentlicht_vorschau": "Published to the preview. The public website stays as it is.",
    "was": "This entry",
    "was_kategorie": "This category",
    "fehler": {
      "anlegen": "Could not create",
      "loeschen": "Could not delete",
      "sortieren": "Could not change the order",
      "umbenennen": "Could not rename",
      "bild": "Image upload failed",
      "bild_entfernen": "Could not remove",
      "veroeffentlichen": "Publishing failed",
      "gibt_es_schon": "“{wert}” already exists.",
      "umhaengen_noetig": "Entries are still assigned to it. Please choose where they should move."
    },
    "feld": {
      "unbekannt": "This field does not exist in this form.",
      "pflicht": "Required",
      "ganze_zahl": "Please enter a whole number.",
      "zahl": "Please enter a number.",
      "ja_nein": "Please choose Yes or No.",
      "text": "Please enter some text.",
      "auswahl": "Please choose one of the given values: {erlaubt}",
      "zu_kurz": "At least {min} characters.",
      "zu_lang": "At most {max} characters, currently {laenge}.",
      "zu_klein": "The value must be at least {min}.",
      "zu_gross": "The value can be at most {max}."
    },
    "was_sammlung": "This collection"
  },
  "vorschau": {
    "keine_eigenen_texte": "This page has no texts of its own in the CMS. You can keep editing {seite}.",
    "texte_ohne_seite": "These texts have no page of their own. Showing {seite}, where they appear. Pick a field {links}: the preview then jumps to the spot and marks it blue.",
    "links": "on the left",
    "so_sieht_es_aus": "This is how it looks on {seite}"
  },
  "verlauf": {
    "diff_fehler": "Could not load the changes",
    "wiederherstellen_frage": "Restore this version (commit {commit})?\n\nA new “restore” commit is created. The current version stays in the history, and you can bring it back at any time.",
    "nichts_zu_tun": "Nothing to do, this version is already current.",
    "wiederhergestellt": "Restored",
    "wiederhergestellt_text": "New commit created. Staging is being rebuilt.",
    "wiederherstellen_fehler": "Restoring failed",
    "laden": "↻ Reload",
    "ohne_git": "This project is not tracked with Git (no {ordner} folder).",
    "diff_auf": "Show changes",
    "diff_zu": "Hide changes",
    "neu": "+ (new)",
    "entfernt": "− (removed)",
    "leer": "(empty)",
    "stellt_wieder_her": "Restoring …",
    "zuruecksetzen": "↶ Restore this version"
  },
  "banner": {
    "staging": "{umgebung}: changes here do not affect the live site (cms.mirateq.com)"
  },
  "vorschaulink": {
    "fehler": "Could not create the link.",
    "fehler_no_staging_url": "No preview address is set up for this website.",
    "fehler_no_staging_token": "The key for this preview is missing on the server. Please let miraTEQ know.",
    "fehler_unknown_site": "This part of the website does not exist in the project.",
    "fehler_mehrere_sites": "This website has several parts. The preview link does not support that yet.",
    "fehler_cloudflare_unvollstaendig": "The website is not fully set up at Cloudflare yet. Please let miraTEQ know.",
    "fehler_schluessel_nicht_angelegt": "The key for the preview could not be created. Please try again in a moment.",
    "im_browser": "Preview in the browser",
    "kopieren_fehler": "Could not copy to the clipboard",
    "erzeugt": "Creating …",
    "erzeugen": "Create preview link",
    "kopiert": "Copied!",
    "kopieren": "Copy to the clipboard"
  },
  "benutzer": {
    "einleitung": "This is our own team, admins and editors. They see every project. {kundenzugaenge} are created in the project itself, under {zugriff}, together with password, rights and link.",
    "derzeit": "There is {n} at the moment. | There are {n} at the moment.",
    "im_team": "{n} in the team",
    "neu": "+ New user",
    "anlegen": "Create user",
    "ohne_projekt": "One customer login without a project is listed here. Assign it or delete it, otherwise no one will find it again. | {n} customer logins without a project are listed here. Assign or delete them, otherwise no one will find them again.",
    "sie_selbst": "(you)",
    "projekte_ausgewaehlt": "Projects ({n} selected)",
    "angelegt": "User {name} created",
    "aktualisiert": "{name} updated",
    "neues_passwort_frage": "New password for {name} (at least 15 characters):",
    "passwort_gesetzt": "Password set for {name}",
    "loeschen_frage": "Really delete user “{name}”? This cannot be undone.",
    "geloescht": "{name} deleted",
    "geloescht_sitzungen": "{name} deleted, {n} open session ended | {name} deleted, {n} open sessions ended",
    "was": "This user",
    "fehler": {
      "nicht_selbst": "You cannot delete yourself.",
      "letzter_admin": "This is the last admin. Make another account an admin first.",
      "passwort": "Could not set the password",
      "loeschen": "Could not delete"
    },
    "konto_rechte": "May also",
    "konto_rechte_hinweis": "These rights require two-factor sign-in.",
    "recht": {
      "websites_anlegen": "create and design new websites",
      "domains_verbinden": "connect domains",
      "kunden_zugang": "create customer logins"
    }
  },
  "zugriff": {
    "mindestens_eine": "At least one mode has to stay on.",
    "was_einstellung": "This setting",
    "was_zugang": "This login",
    "was_link": "This link",
    "nie_geoeffnet": "never opened",
    "zuletzt": "last opened on {datum}, {n}×",
    "zugang_unvollstaendig": "Please enter a username and a password with at least 15 characters.",
    "kopieren_fehler": "Copying did not work. Please select the link by hand.",
    "erst_texte": "Allow changing texts first",
    "aktiv": "Active",
    "aus": "Off",
    "kopiert": "Copied",
    "abschalten": "Turn off",
    "einschalten": "Turn on",
    "abschnitte_umbauen": "Rearrange sections",
    "abschnitte_umbauen_hinweis": "Add, move and delete the sections of a page",
    "claude_an": "Claude may work in this project",
    "claude_an_hinweis": "Texts and layout of this website are sent to Anthropic. Only switch on once the customer knows. Claude only changes the preview; people publish."
  },
  "hinweisseiten": {
    "zustand": {
      "private": "No valid link",
      "expired": "Link expired",
      "config": "Setting missing",
      "notfound": "Page not found"
    },
    "feld": {
      "title": "Heading",
      "text": "Text",
      "cta": "Button"
    },
    "laden_fehler": "Could not load the texts",
    "gespeichert": "Saved. Visible on every preview address right away.",
    "zu_lang": "Too long: {feld} (400 characters at most)",
    "nur_admins": "Only admins can change these texts.",
    "abweichend": "{n} text differs from the default. | {n} texts differ from the default."
  },
  "farben": {
    "aa_gross": "AA large · {wert}",
    "zu_niedrig": "too low · {wert}",
    "laden_fehler": "Could not load the colours",
    "gespeichert": "Colours saved",
    "gespeichert_text": "The page has been rebuilt.",
    "untertitel": "{projekt}: change brand colours",
    "keine": "No colours are set up for this project ({datei} is missing).",
    "ungueltig": "Invalid colour",
    "alles_gespeichert": "Everything saved",
    "speichert": "Saving and building …",
    "speichern": "Save & apply"
  },
  "alt": {
    "bitte_pruefen": "Please check",
    "bild_ersetzt": "The image was replaced. Does the image description still fit the new image? Screen readers and search engines read it instead of the image.",
    "jetzt": "Current description",
    "leer": "(empty)",
    "passt_so": "Still fits",
    "beschreibung_oeffnen": "Edit image description",
    "passt_so_fehler": "The confirmation was not saved."
  },
  "abschnitte": {
    "was": "this section",
    "liste": "Sections of this page",
    "leer": "This page has no sections yet.",
    "nur_lesen": "Only people with permission can change the layout of this page. You can edit texts as usual.",
    "laden_fehlgeschlagen": "Could not load the sections",
    "ziehen": "Drag to move",
    "hoch": "Move {name} up",
    "runter": "Move {name} down",
    "menue": "What to do with “{name}”",
    "hinzufuegen": "Add section",
    "darunter_einfuegen": "Add section below",
    "keine_bausteine": "No building blocks are set up for this project.",
    "variante": "Layout",
    "hintergrund": "Background",
    "hintergrund_standard": "Same as page",
    "gewaehlt": "selected",
    "duplizieren": "Duplicate",
    "loeschen": "Delete",
    "loeschen_hinweis": "Including its texts in every language",
    "loeschen_frage": "Delete “{name}” including its texts in every language? You can bring it back from the history.",
    "erledigt": {
      "anlegen": "Section added",
      "verschieben": "Section moved",
      "duplizieren": "Section duplicated",
      "loeschen": "Section deleted",
      "variante": "Layout changed",
      "hintergrund": "Background changed",
      "eintrag_anlegen": "Entry added",
      "eintrag_verschieben": "Entry moved",
      "eintrag_loeschen": "Entry deleted",
      "abstand": "Spacing changed",
      "schleier": "Image overlay changed",
      "anker": "Anchor changed",
      "ausblenden": "Section visibility changed",
      "geraet": "Device visibility changed",
      "bewegung": "Section motion changed"
    },
    "fehler": {
      "kein_recht": "You are not allowed to change the layout of this page.",
      "kein_plan": "This page is not built from building blocks.",
      "kein_katalog": "No building blocks are set up for this project.",
      "weg": "This section no longer exists. The list is up to date again.",
      "baustein_unbekannt": "The website does not know this building block.",
      "zu_viele": "A page cannot hold more than {max} sections.",
      "zu_wenige_eintraege": "At least {min} entries have to stay.",
      "zu_viele_eintraege": "No more than {max} entries are possible here.",
      "ungueltig": "The change does not fit the building blocks of the website and was not saved.",
      "ohne_titel": "A page needs a title.",
      "keine_adresse": "No address can be made from this title. Please use a few more letters.",
      "nur_entwurf": "Only miraTEQ can delete a visible page. Set it back to draft first.",
      "eigene_seite": "This page is built in and cannot be deleted here.",
      "gleiche_adresse": "The page already has this address.",
      "adresse_vergeben": "Another page already uses this address. Please choose a different one.",
      "kein_menue": "This website has no menu that can be managed in the CMS.",
      "menue_seite_weg": "A page in the menu no longer exists. Please reload.",
      "menue_doppelt": "A page appears twice in the same menu.",
      "menue_zu_viele": "No more than {max} pages fit in one menu.",
      "keine": "This can no longer be undone. Older versions can be restored from the history.",
      "fremd": "This change was made by someone else. Use the history to restore it.",
      "konflikt": "The same spot was changed afterwards, so undo is not possible here. Use the history to restore it.",
      "anker_ungueltig": "This anchor does not work: only lowercase letters, digits and hyphens, and some names are taken.",
      "anker_doppelt": "Another section on this page already has this anchor.",
      "abstand_unbekannt": "The website does not know this spacing. Please reload the page.",
      "schleier_unbekannt": "The website does not know this image overlay. Please reload the page.",
      "ausblenden_nicht": "This website cannot hide sections yet.",
      "vorlage_unbekannt": "This template is not available here. Please reload the page.",
      "geraet_unbekannt": "The website does not know this device setting.",
      "bewegung_unbekannt": "The website does not know this motion. Please reload the page.",
      "menue_link_leer": "This link has no name or target. Please enter both under “For all pages”."
    },
    "neue_seite": "New page from building blocks",
    "seitentitel": "Page title",
    "seitentitel_hinweis": "The address, page title and first heading are made from it. You can change everything later.",
    "neue_seite_entwurf": "Starts as a draft. It only appears on the website once you make it visible.",
    "eintrag": {
      "gruppe": "{name} {nr} of {von}",
      "stelle": "{name} {nr} of {von}",
      "hoch": "Move up",
      "runter": "Move down",
      "dazu": "Add {name}",
      "loeschen": "Delete",
      "loeschen_frage": "Delete {name} {nr} including its text in every language?"
    },
    "wird_angelegt": "Being created …",
    "vorschau_neu": "New section: {name}. Building …",
    "vorschau_wartet": "Updating …",
    "abstand": "Spacing above and below",
    "abstand_normal": "Normal",
    "hoehe": "Height of the hero",
    "hoehe_kompakt": "Compact",
    "hoehe_normal": "Normal",
    "hoehe_gross": "Full screen",
    "schleier": "Image overlay",
    "schleier_normal": "Normal",
    "anker_setzen": "Set anchor",
    "anker_aendern": "Change anchor #{anker}",
    "anker_hinweis": "A button can then link here",
    "anker_titel": "Anchor for this section",
    "anker_erklaerung": "A button with the link #{anker} jumps to this section.",
    "anker_ungueltig": "Only lowercase letters, digits and hyphens, starting with a letter.",
    "anker_entfernen": "Remove",
    "ausblenden": "Hide",
    "ausblenden_hinweis": "Kept, but not published",
    "einblenden": "Show again",
    "ausgeblendet": "hidden",
    "seite_kopieren": "Copy “{name}”",
    "vorlage": "Start with",
    "seite_duplizieren": "Copy page",
    "seite_duplizieren_hinweis": "As a draft with a new title",
    "vorlagen": {
      "leer": "Empty",
      "leistungen": "Services",
      "ueber-uns": "About us",
      "preise": "Prices",
      "kontakt": "Contact",
      "gutschein": "Gift voucher",
      "beitrag": "Post",
      "neuigkeiten": "News"
    },
    "vorlagen_hinweis": {
      "leer": "Just an intro, you add the rest yourself",
      "leistungen": "Intro, services, benefits, questions, call to action",
      "ueber-uns": "Intro, text with image, figures, team, quote, call to action",
      "preise": "Intro, price list, questions, call to action",
      "kontakt": "Intro, form, opening hours, map",
      "gutschein": "Intro, text with image, steps, questions, call to action",
      "beitrag": "Intro, text, call to action, dated today",
      "neuigkeiten": "Intro, all posts"
    },
    "geraet": "Visible on",
    "geraet_alle": "All devices",
    "bewegung": "Motion on scroll",
    "bewegung_website": "Like the whole website"
  },
  "webmenue": {
    "titel": "Website menu",
    "kopf": "Top, in the header",
    "fuss": "Bottom, in the footer",
    "leer": "No page here yet.",
    "entfernen": "Remove {name} from this menu",
    "hinzufuegen": "Add page: {wo}",
    "voll": "No more than {max} pages fit",
    "seite_hinzufuegen": "Add page …",
    "name_hinweis": "To change how a page is named in the menu, edit the field “Name im Menü” on that page.",
    "bearbeiten": "Edit menu",
    "rein": "Add to menu",
    "rein_hinweis": "Appears at the end of the header menu",
    "raus": "Remove from menu",
    "raus_hinweis": "The page stays, it just leaves the menu",
    "drin": "“{name}” is now in the menu",
    "draussen": "“{name}” is no longer in the menu",
    "einruecken": "Indent “{name}” under the page above",
    "ausruecken": "Move “{name}” back to the top level",
    "links_hinweis": "Own links, for example to online booking or to “/#prices”, are set up under “For all pages” in the Menu group. Then they appear here with an arrow."
  },
  "adresse": {
    "titel": "Change the address of “{name}”",
    "feld": "New address",
    "vorschau": "Becomes",
    "regeln": "Please use at least three letters or digits.",
    "hinweis_entwurf": "The page is still a draft. Its old address was never public and needs no redirect.",
    "hinweis_weiterleitung": "Anyone opening the old address will land on the new one. Links and Google results keep working.",
    "aendern": "Change address",
    "wird_geaendert": "Changing …",
    "menue": "Change address",
    "menue_hinweis": "Old links keep working",
    "erst_speichern": "This page has unsaved changes. Save first, then the address can be changed.",
    "geaendert": "The page now has the address {adresse}"
  },
  "rueckgaengig": {
    "knopf": "Undo: {was}",
    "knopf_vor": "Redo: {was}",
    "titel_zurueck": "Undo: {was} (Cmd+Z)",
    "titel_vor": "Redo: {was} (Cmd+Shift+Z)",
    "kuerzel_zurueck": "Cmd+Z",
    "kuerzel_vor": "Cmd+Shift+Z",
    "nichts": "Nothing to undo",
    "nichts_vor": "Nothing to redo",
    "erledigt": "Undone: {was}",
    "wiederholt": "Redone: {was}",
    "ging_nicht": "Undo failed",
    "art": {
      "anlegen": "Section added",
      "verschieben": "Section moved",
      "duplizieren": "Section duplicated",
      "loeschen": "Section deleted",
      "variante": "Layout changed",
      "hintergrund": "Background changed",
      "eintrag_anlegen": "Item added",
      "eintrag_verschieben": "Item moved",
      "eintrag_loeschen": "Item deleted",
      "sichtbar": "Page made visible",
      "entwurf": "Page set to draft",
      "seite_anlegen": "Page created",
      "seite_loeschen": "Page deleted",
      "adresse": "Address changed",
      "menue": "Menu changed",
      "abstand": "Spacing changed",
      "schleier": "Image overlay changed",
      "anker": "Anchor changed",
      "ausblenden": "Section visibility changed",
      "suche_aus": "Page hidden from search engines",
      "suche_an": "Page shown in search engines again",
      "geraet": "Device visibility changed",
      "bewegung": "Section motion changed",
      "landing_an": "Page set as landing page, no menu",
      "landing_aus": "Page shows the menu again",
      "beitrag_an": "Page set as post",
      "beitrag_aus": "Page is no longer a post"
    }
  },
  "claude": {
    "titel": "Connect Claude",
    "einleitung": "With your own Claude you can have texts and sections changed by asking, for example “make the questions on the home page easier to understand”. Claude works with your permissions, only in projects where miraTEQ has switched it on, and only in the preview. Publishing stays with you. Everyone needs their own Claude account.",
    "ist_aus": "Claude is currently blocked for everyone. Your keys stay valid and work again once the block is lifted.",
    "neuer_schluessel": "Create a new key",
    "name": "What it is for, so you recognise it later",
    "name_beispiel": "Claude on my laptop",
    "erzeugen": "Create",
    "nur_einmal": "The key is only shown now. Enter it right away; after that miraCMS no longer knows it.",
    "app_schritt": "In the Claude app, add a custom connector under Settings, Connectors, with this address, and under the request headers “Authorization” with this value:",
    "adresse": "Address",
    "kopfzeile": "Value for Authorization",
    "code_schritt": "Or run this command in Claude Code:",
    "kopieren": "Copy",
    "kopiert": "Copied",
    "nicht_kopiert": "Copying did not work. Please select and copy by hand.",
    "fertig_eingetragen": "Entered, hide",
    "meine": "My keys",
    "keine": "No key yet.",
    "erzeugt_am": "created {datum}",
    "zuletzt_am": "last used {datum}",
    "nie": "never",
    "abschalten": "Switch off",
    "abgeschaltet": "switched off",
    "abschalten_frage": "Switch off key “{name}”? Claude can no longer get in with it, immediately.",
    "notschalter": "Emergency switch",
    "notschalter_hinweis": "Blocks all Claude keys at once, in every project. For when something goes wrong and there is no time to search.",
    "schalter_aus": "Block Claude for everyone",
    "schalter_an": "Lift the block",
    "schalter_aus_erledigt": "Claude is blocked for everyone",
    "schalter_an_erledigt": "Claude is allowed again",
    "laden_fehler": "Could not load the Claude settings",
    "erzeugen_fehler": "Could not create the key",
    "letzte_aenderung": "Last change by Claude",
    "zuruecknehmen": "Undo",
    "zuruecknehmen_frage": "Undo the Claude change “{was}”? Anything changed by hand afterwards stays.",
    "zurueckgenommen": "Claude change undone",
    "konflikt": "That spot was changed by hand afterwards. Please restore the fields one by one from their history."
  },
  "assistent": {
    "titel": "Assistant",
    "einleitung": "The assistant is an AI (Claude by Anthropic). Write what should change on the website: it edits texts and sections in the preview, and nothing goes live until you publish it.",
    "verlauf": "Conversation with the assistant",
    "beispiele_titel": "For example:",
    "beispiel_1": "Make the heading at the top friendlier.",
    "beispiel_2": "Add a question about opening hours.",
    "beispiel_3": "Move the FAQ to the end of the page.",
    "eingabe": "Your request to the assistant",
    "platzhalter": "What should change?",
    "senden": "Send",
    "arbeitet": "Working …",
    "denkt": "Reading and thinking …",
    "neues_gespraech": "New conversation",
    "bild_anhaengen": "Attach image",
    "bild_laedt": "Uploading …",
    "bild_fehler": "The image could not be uploaded.",
    "bild_hoechstens": "At most {n} images per message.",
    "bild_entfernen": "Remove image {nr}",
    "bilder_angehaengt": "Attached images",
    "budget": "This month {verbraucht} of {grenze}",
    "kosten_gespraech": "this conversation {usd}",
    "aenderungen": "{n} change in the preview | {n} changes in the preview",
    "zuruecknehmen": "Undo",
    "zurueckgenommen": "Changes undone",
    "nicht_gesendet": "Not sent",
    "schritt_abgelehnt": "rejected",
    "grund_admin": "Set it up under Settings, Claude tab, section Assistant in the CMS.",
    "schritt": {
      "list_pages": "Looks through the pages",
      "list_blocks": "Looks through the building blocks",
      "read_page": "Reads the page",
      "view_page": "Looks at the page",
      "list_media": "Looks through the images",
      "set_texts": "Changes texts",
      "add_section": "Adds a section",
      "move_section": "Moves a section",
      "duplicate_section": "Copies a section",
      "delete_section": "Deletes a section",
      "configure_section": "Changes the layout",
      "add_entry": "Adds an entry",
      "move_entry": "Moves an entry",
      "delete_entry": "Deletes an entry",
      "create_page": "Creates a page",
      "search_stock_images": "Searches photos",
      "import_image": "Adds a photo",
      "list_styles": "Looks at the styles",
      "set_style": "Changes the look",
      "build_page": "Builds a whole page",
      "set_menu": "Arranges the menu",
      "sonst": "Working",
      "set_brand_profile": "Saves the brand profile"
    },
    "grund": {
      "abgeschaltet": "The assistant is switched off on this installation.",
      "kein_schluessel": "The assistant is not set up yet.",
      "bilder": "An attached image is no longer in the media library. Please attach it again.",
      "ki_aus": "Claude is not enabled for this project.",
      "notschalter": "Claude is currently locked for everyone.",
      "kein_recht": "You may not change texts in this project.",
      "budget": "The limit for this month has been reached.",
      "laeuft_schon": "The assistant is still working on the last request.",
      "schluessel_ungueltig": "Anthropic rejected the access. Please let miraTEQ know.",
      "limit": "The monthly limit at Anthropic has been reached.",
      "guthaben": "This month's Claude credit is used up. New credit arrives with the next monthly billing.",
      "ueberlastet": "Claude is overloaded right now. Please try again in a minute.",
      "netz": "Claude could not be reached. Please try again.",
      "abgebrochen": "The request was interrupted. Please send it again.",
      "unbekannt": "That did not work. Please try again."
    },
    "einstellungen": {
      "titel": "Assistant in the CMS",
      "text": "For the assistant to work in the panel, miraCMS needs an API key from the Anthropic Claude Console. A Max or Team plan includes monthly credit: on claude.ai, link the Console organization under Settings, Billing, and create the key there. When the credit is used up, the assistant pauses until the next monthly billing. The limits here apply on top.",
      "schluessel": "API key",
      "schluessel_da": "Stored, ends in {ende}",
      "schluessel_fehlt": "No key stored",
      "schluessel_neu": "New key",
      "schluessel_speichern": "Save key",
      "schluessel_entfernen": "Remove key",
      "entfernen_frage": "Remove the key? The assistant will stop working.",
      "fehler_schluessel": "That does not look like an Anthropic API key, which starts with sk-ant-.",
      "modell": "Model",
      "modell_sonnet": "Sonnet 5.5, recommended",
      "modell_haiku": "Haiku 5.5, cheaper",
      "modell_opus": "Opus 5.5, more thorough and more expensive",
      "grenze_projekt": "Limit per project and month in US dollars",
      "grenze_gesamt": "Limit for all projects and month in US dollars",
      "speichern": "Save",
      "gespeichert": "Saved",
      "laden_fehler": "Settings could not be loaded",
      "verbrauch": "Usage in month {monat}",
      "verbrauch_gesamt": "total {usd}",
      "kein_verbrauch": "Nothing used yet.",
      "spalte_projekt": "Project",
      "spalte_auftraege": "Requests",
      "spalte_kosten": "Cost"
    },
    "auftrag_uebersetzen": "Translate the page “{name}” ({seite}) into every other language of the website. Same meaning and tone as the original, keep the lengths, no PLATZHALTER may remain.",
    "umschreiben": "With Claude",
    "umschreiben_kuerzer": "Shorter",
    "umschreiben_freundlicher": "Friendlier",
    "umschreiben_variante": "Another version",
    "auftrag_kuerzer": "In the field “{feld}” (key {key}) on the page “{seite}” in language {lang}, write a shorter version. Keep content and tone, just more concise.",
    "auftrag_freundlicher": "In the field “{feld}” (key {key}) on the page “{seite}” in language {lang}, write a friendlier, warmer version. Keep the content, add no new claims.",
    "auftrag_variante": "In the field “{feld}” (key {key}) on the page “{seite}” in language {lang}, write another version in new words. Keep content, length and tone similar.",
    "vorher_pruefen": "Let Claude check first",
    "auftrag_pruefen": "Before publishing, check all pages in all languages: leftover placeholders, typos, contradicting details such as different prices or times, empty image descriptions and texts that do not match the brand profile. Change nothing, just list the spots with page and field.",
    "auftrag_sprache": "Translate all pages of the website into {name} ({lang}). The texts there are still copies of the main language. Keep meaning and tone, respect the lengths, page by page, and report at the end whether everything is translated."
  },
  "mediathek": {
    "titel": "Media library",
    "hinweis": "All images in this project",
    "auswahl_titel": "Image from the media library",
    "aus_der_mediathek": "From media library",
    "anzahl": "{n} image | {n} images",
    "suche": "Search the media library",
    "suche_platzhalter": "File name",
    "nur_ungenutzte": "Unused only",
    "hochladen": "Upload",
    "bilder": "Images",
    "laedt": "Loading images …",
    "was": "The media library",
    "leer": "This project has no images yet.",
    "nichts_gefunden": "No image matches this search.",
    "im_feld": "In this field",
    "stand": {
      "verwendet": "Used in {n} place | Used in {n} places",
      "genannt": "Mentioned in {n} file | Mentioned in {n} files",
      "frei": "Not used",
      "eingebaut": "Part of the design",
      "in_arbeit": "In an unsaved field"
    },
    "masse": "{breite} × {hoehe} px",
    "kb": "{n} KB",
    "mb": "{n} MB",
    "zurueck": "All images",
    "verwendet_auf": "Used on",
    "zum_feld": "Go to the field",
    "genannt_in": "Also mentioned in",
    "genannt_hinweis": "These files are part of the website itself. miraTEQ looks after the image there.",
    "eingebaut_hinweis": "This image came with the website's code and is part of its design. Only miraTEQ can delete it.",
    "in_arbeit_hinweis": "You put this image into a field that is not saved yet, so it cannot be deleted.",
    "frei_hinweis": "This image is not on any page or in any file. You can delete it.",
    "loeschen": "Delete image",
    "loeschen_frage": "Delete “{name}” for good?",
    "loeschen_text": "The image disappears from the project. Only miraTEQ can bring it back.",
    "loescht": "Deleting …",
    "geloescht": "“{name}” deleted",
    "nicht_gesichert": "Deleted, but not backed up yet",
    "nicht_gesichert_text": "The change is on the server but not on GitHub yet. Please let miraTEQ know before you publish.",
    "fehler": {
      "in_gebrauch": "The image is now used somewhere else, so it stays.",
      "fest_eingebaut": "This image is part of the website's design. Only miraTEQ can delete it.",
      "nicht_gefunden": "This image no longer exists.",
      "nicht_gesichert": "The deletion could not be backed up, so the image is still there. Please try again.",
      "loeschen": "The image could not be deleted. Please try again."
    },
    "reiter": "Image source",
    "reiter_mediathek": "Own images",
    "reiter_stock": "Stock photos",
    "reiter_ki": "AI image"
  },
  "werkbank": {
    "fortschritt": "Progress",
    "in_arbeit": "New websites in progress",
    "noch_einmal": "Try again",
    "laeuft_weiter": "This keeps running if you close this window.",
    "stand": {
      "erledigt": "done",
      "laeuft": "in progress",
      "offen": "not started",
      "gestoppt": "stopped"
    },
    "schritt": {
      "website_anlegen": {
        "werkbank": "Create the website from the template",
        "klonen": "Bring it onto the server",
        "pakete": "Install the building blocks",
        "startpaket": "Create the industry starter pack",
        "bauen": "Build the first preview"
      },
      "domain_vorbereiten": {
        "werkbank": "Add the domain at Cloudflare and copy the existing records",
        "adresse": "Switch the website address"
      },
      "domain_aktivieren": {
        "werkbank": "Connect the website to the domain",
        "rauchtest": "Check from outside that the site loads (the certificate can take a few minutes)"
      }
    },
    "fehler": {
      "forbidden": "Your account does not have permission for this.",
      "zwei_faktor_noetig": "This requires two-factor sign-in. Please turn it on under Account first.",
      "bestaetigung_noetig": "Please confirm this step with the code from your app.",
      "werkbank_nicht_eingerichtet": "Creating new websites is not set up yet. Please contact miraTEQ.",
      "cloudflare_nicht_eingerichtet": "Publishing to Cloudflare is not set up yet. Please contact miraTEQ.",
      "name_fehlt": "Please enter the business name.",
      "name_ungueltig": "The name is too long or contains characters that are not allowed.",
      "kurzname_ungueltig": "The short name may only contain lowercase letters, digits and single hyphens, 3 to 32 characters, starting with a letter.",
      "kurzname_vergeben": "This short name is already taken. Please choose another one.",
      "land_ungueltig": "Please choose Germany or Thailand.",
      "sprachen_ungueltig": "Please choose at least one language and one of them as the main language.",
      "farbe_ungueltig": "The colour is not valid.",
      "branche_ungueltig": "This sector does not exist.",
      "repo_gibt_es_schon": "There is already a website for this short name. Please choose another one.",
      "lauf_nicht_gefunden": "The workbench did not pick up the job. Please try again later or let miraTEQ know.",
      "lauf_zu_lang": "The job took too long and was stopped. Please let miraTEQ know.",
      "kein_ergebnis": "The workbench returned no result. Please let miraTEQ know.",
      "klonen_fehlgeschlagen": "The new website could not be brought onto the server. Please let miraTEQ know.",
      "pakete_fehlgeschlagen": "The building blocks could not be installed. Please let miraTEQ know.",
      "erster_bau_fehlgeschlagen": "The first preview could not be built. Please let miraTEQ know.",
      "zugang_abgelehnt": "The workbench rejected the access. Please let miraTEQ know.",
      "werkbank_fehlt": "The workbench cannot be reached. Please let miraTEQ know.",
      "github_gestoert": "GitHub is having problems right now. Please try again in a few minutes.",
      "netz": "No connection. Please try again.",
      "tagesgrenze": "Enough new websites or domains have been set up for today. It works again tomorrow.",
      "domain_ungueltig": "That is not a domain that can be connected. Please enter just the name without www or a subpage, for example customer.com.",
      "domain_gesperrt": "This domain belongs to miraTEQ and cannot be connected here.",
      "domain_schon_aktiv": "The domain is already connected.",
      "laeuft_schon": "A job is already running for this project. Please wait until it has finished.",
      "zone_noch_nicht_aktiv": "Cloudflare has not taken over the domain yet. Have the name servers been changed at the provider? This can take a few hours.",
      "rauchtest_fehlgeschlagen": "The website does not respond under the domain yet. Please let miraTEQ know.",
      "email_ungueltig": "That is not a valid email address.",
      "mail_nicht_verschickt": "The confirmation email could not be sent. Please try again later.",
      "link_ungueltig": "The link is no longer valid.",
      "benutzername_ungueltig": "The username may only contain lowercase letters, digits, dots, underscores and hyphens, 2 to 32 characters.",
      "benutzername_vergeben": "This username already exists.",
      "nur_kunde": "Only the customer can give the approval.",
      "vorabpruefung_offen": "The pre-publish check still found something that has to be done first.",
      "erster_livegang_unvollstaendig": "Something is still missing for the first go-live.",
      "adresse_nicht_gespeichert": "The new address could not be saved. Please let miraTEQ know.",
      "unbekannt": "That did not work. Please try again or let miraTEQ know.",
      "adresse_fehlt": "No address is set for this website. Please contact miraTEQ.",
      "erster_livegang_nur_im_panel": "The first go-live of this website only works through “Publish to live”.",
      "domain_ausserhalb": "The domain of this website is already connected, miraTEQ manages it."
    },
    "neu": {
      "knopf": "New website",
      "titel": "Create a new website",
      "laeuft": "The website “{name}” is being created.",
      "fertig": "The website “{name}” is ready.",
      "oeffnen": "Open website",
      "nicht_eingerichtet": "Creating new websites is not set up yet. Please contact miraTEQ.",
      "name": "Business name",
      "kurzname": "Short name",
      "kurzname_hinweis": "For the internal address: lowercase letters, digits and hyphens, 3 to 32 characters.",
      "land": "Country",
      "sprachen": "Website languages",
      "hauptsprache": "Main language:",
      "branche": "Industry",
      "branche_allgemein": "Starts with a home page and contact page, you build the rest.",
      "branche_paket": "Starts with a style, a home page and matching pages, texts as placeholders. You can change everything afterwards.",
      "farbe": "Brand colour",
      "knopf_beispiel": "This is how a button looks",
      "knopf_dunkler": "For buttons with white text the website uses a darker shade ({ton}) so it stays easy to read.",
      "wird_angelegt": "Creating …",
      "anlegen": "Create website"
    },
    "zwei_faktor_zuerst": "New websites and domains require two-factor sign-in on your account. Please turn it on first.",
    "zwei_faktor_einrichten": "Set up two-factor sign-in",
    "land": {
      "DE": "Germany",
      "TH": "Thailand"
    },
    "sprache": {
      "de": "German",
      "en": "English",
      "th": "Thai"
    },
    "branche": {
      "allgemein": "General (no starter pack)",
      "massage": "Massage and spa",
      "restaurant": "Restaurant and café",
      "praxis": "Practice and therapy",
      "hotel": "Hotel and accommodation",
      "handwerk": "Trades and services"
    }
  },
  "bestaetigung": {
    "titel": "Confirm with code",
    "text": "This step affects a domain or a new website. Please enter the code from your authenticator app; miraCMS will not ask again for ten minutes.",
    "code": "Code",
    "weiter": "Confirm",
    "falsch": "The code is not correct. Please enter the current code.",
    "gesperrt": "Too many attempts. Please try again in fifteen minutes.",
    "fehler": "That did not work. Please try again."
  },
  "einrichtung": {
    "knopf": "Setup",
    "knopf_hinweis": "Domain, contact form and customer approval",
    "titel": "Setup: {name}",
    "fehlt_titel": "Still missing for the first go-live",
    "bereit": "Everything is ready. The website can go live for the first time.",
    "kopiert": "Copied",
    "kopieren": "Copy",
    "fehlt": {
      "domain_fehlt": "The domain is not connected yet.",
      "nameserver_fehlen": "The name servers have not been changed at the domain provider yet.",
      "abnahme_fehlt": "The customer has not approved the website yet.",
      "formular_empfaenger_fehlt": "The contact form does not have a confirmed recipient address yet."
    },
    "domain": {
      "titel": "Domain",
      "status": {
        "vorbereitet": "waiting for the name servers",
        "nameserver": "name servers changed",
        "aktiv": "connected"
      },
      "nameserver_eintragen": "At the domain provider (for example IONOS or GoDaddy), enter these two name servers. The customer does this, or you with their login:",
      "anleitung_kopieren": "Copy instructions for the customer",
      "jetzt_pruefen": "Check now",
      "nameserver_ok": "The name servers are correct. The website will be connected to the domain at the first go-live.",
      "aktiv_seit": "Connected since {datum}.",
      "eintraege": "{n} copied record | {n} copied records",
      "fehlen": "{n} record could not be copied | {n} records could not be copied",
      "typ": "Type",
      "name": "Name",
      "inhalt": "Value",
      "erklaerung": "The customer's domain moves to Cloudflare. miraCMS copies the existing records, including those for email; the website is only connected at the first go-live.",
      "feld": "Domain",
      "beispiel": "customer.com",
      "vorbereiten": "Prepare",
      "hauptadresse": "Main address",
      "ohne_www": "without www",
      "mit_www": "with www",
      "kein_recht": "Only accounts with this right can connect a domain.",
      "anleitung_text": "Please change the name servers for {domain} at your domain provider to {ns1} and {ns2}. All other settings stay as they are, and your email keeps working. The change can take a few hours.",
      "erst_klaeren": "Some existing records could not be copied (see below). Please do not change the name servers yet, or the customer's email may be lost, and let miraTEQ know.",
      "ausserhalb": "The domain is connected. miraTEQ set it up when moving the website to Cloudflare."
    },
    "formular": {
      "titel": "Contact form",
      "bestaetigt": "confirmed",
      "wartet": "waiting for confirmation",
      "noetig": "The website has a contact form. Where should enquiries go?",
      "optional": "If the website gets a contact form: where should enquiries go?",
      "feld": "Email address for enquiries",
      "beispiel": "Address for enquiries",
      "senden": "Send confirmation link",
      "gesendet": "The address will receive an email with a confirmation link."
    },
    "abnahme": {
      "titel": "Customer approval",
      "freigegeben": "Approved by {name} on {datum}.",
      "offen": "Not approved yet. Send the customer the guest link; there they click “Approve website”.",
      "gast_link": "Open guest link"
    },
    "zugang": {
      "titel": "Customer login",
      "einmalig": "The password is only shown now. Please pass it on to the customer securely; they can change it afterwards.",
      "name": "Name",
      "benutzername": "Username",
      "anlegen": "Create login"
    }
  },
  "gestalten": {
    "titel": "Font and corners",
    "schrift": "Font",
    "mit_thai": "{name} (with Thai)",
    "ecken": "Corners of buttons and cards",
    "ecken_eckig": "square",
    "ecken_leicht": "slightly rounded",
    "ecken_rund": "rounded",
    "logo_hinweis": "You manage the logo and site icon in the editor, in the fields for all pages.",
    "knopf_dunkler": "Buttons with white text get the darker shade {ton} so they are easy to read.",
    "stile_titel": "Style",
    "stile_hinweis": "A style sets colours, fonts and corners together. Afterwards you can adjust each value on its own.",
    "schrift_ueberschrift": "Heading font",
    "wie_text": "Same as text",
    "fehler": {
      "zu_wenig_kontrast": "This colour has too little contrast: text on the page background or white text on dark sections would be hard to read. Please choose another shade.",
      "invalid_color": "A colour has an invalid format. Please choose it again.",
      "ungueltige_schrift": "This font does not suit body text. Please choose another one.",
      "ungueltige_schrift_ueberschrift": "This font is not available here. Please choose another one.",
      "ungueltige_ecken": "These corners do not exist. Please choose again.",
      "unbekannter_stil": "This style no longer exists here. Please reload the page.",
      "ungueltige_einstellung": "The website does not know this setting. Please reload the page."
    },
    "einstellungen_titel": "Type, buttons, header, pattern and motion",
    "automatisch": "Automatic",
    "automatisch_aktiv": "automatic, follows the brand colour",
    "automatisch_hinweis": "The website derives this colour from the brand colour",
    "einstellung": {
      "titel_groesse": "Heading size",
      "text_groesse": "Text size",
      "titel_staerke": "Heading weight",
      "titel_abstand": "Heading letter spacing",
      "knopf_stil": "Buttons",
      "kopf": "Header when scrolling",
      "muster": "Background pattern",
      "kopf_ueber_bild": "Header over the hero image",
      "bewegung": "Reveal on scroll",
      "parallaxe": "Large images move with the page (parallax)",
      "tempo": "Speed of the scroll animation",
      "fuss": "Footer",
      "kopf_stil": "Header layout",
      "handy_menue": "Menu on phones",
      "bild_look": "Photo look for all images"
    },
    "wert": {
      "titel_groesse": {
        "kompakt": "Compact",
        "normal": "Normal",
        "gross": "Large",
        "sehr_gross": "Very large"
      },
      "text_groesse": {
        "normal": "Normal",
        "gross": "Large"
      },
      "titel_staerke": {
        "normal": "Regular",
        "halbfett": "Semibold",
        "fett": "Bold"
      },
      "titel_abstand": {
        "eng": "Tight",
        "normal": "Normal",
        "weit": "Wide"
      },
      "knopf_stil": {
        "voll": "Filled",
        "rahmen": "Outlined",
        "sanft": "Soft tint",
        "akzent_rahmen": "Thin accent outline with arrow"
      },
      "kopf": {
        "mitlaufend": "Scrolls away",
        "klebend": "Stays on top",
        "einblendend": "Hides while reading, returns when scrolling up"
      },
      "muster": {
        "keins": "None",
        "sterne": "Starry sky (only on a dark page background)"
      },
      "kopf_ueber_bild": {
        "aus": "Above it",
        "an": "See-through on the image (on a light page background with the light version of the logo)"
      },
      "bewegung": {
        "aufsteigen": "Rises gently",
        "sanft": "Fades in softly",
        "zoom": "Grows in slightly",
        "aus": "No motion"
      },
      "parallaxe": {
        "aus": "Off",
        "an": "On"
      },
      "tempo": {
        "ruhig": "Calm",
        "normal": "Normal",
        "lebhaft": "Lively"
      },
      "fuss": {
        "standard": "Two columns",
        "spalten": "Columns with headings",
        "schlicht": "Simple, centred"
      },
      "kopf_stil": {
        "standard": "Logo left, menu right",
        "mittig": "Logo and menu centred"
      },
      "handy_menue": {
        "liste": "Opens as a list",
        "vollbild": "Full screen"
      },
      "bild_look": {
        "natur": "Natural",
        "warm": "Warm",
        "kuehl": "Cool",
        "kraeftig": "Vivid",
        "sanft": "Soft",
        "schwarzweiss": "Black and white"
      }
    },
    "farbe": {
      "color-primary": "Brand colour (buttons, links, accents)",
      "color-text": "Text colour",
      "color-akzent": "Accent colour (coloured words, highlights)",
      "color-kante": "Page background",
      "color-tief": "Dark sections"
    },
    "gruppe": {
      "marke": "Brand colours",
      "flaechen": "Surfaces"
    },
    "paare_titel": "Font pairings",
    "paare_hinweis": "One click sets heading and body. Below, each font can still be changed on its own."
  },
  "freigabe": {
    "titel": "Approve website",
    "text": "If everything looks right, approve the website here. Only then does it go online for the first time.",
    "knopf": "Approve website",
    "name": "Your name",
    "gesehen": "I have reviewed the website and approve it for publication.",
    "bestaetigen": "Approve",
    "erledigt": "Approved by {name} on {datum}. Thank you!"
  },
  "empfaenger": {
    "seitentitel": "Confirm address",
    "ok_titel": "Address confirmed",
    "ok_text": "Enquiries from the contact form of {name} will now be sent to this address.",
    "ungueltig_titel": "Link not valid",
    "ungueltig_text": "The link has expired or has already been used. Please ask miraTEQ for a new one."
  },
  "stock": {
    "suche": "Search stock photos",
    "suche_platzhalter": "What should it show? English finds most, e.g. thai massage",
    "quelle": "Source",
    "ausrichtung": "Orientation",
    "ausrichtung_egal": "Any orientation",
    "ausrichtung_quer": "Landscape",
    "ausrichtung_hoch": "Portrait",
    "suchen": "Search",
    "sucht": "Searching …",
    "herkunft": "Photos from {anbieter}. Free to use, also commercially, without credit on the website. Do not use photos of people as your team.",
    "ergebnisse": "Photos found",
    "nichts_gefunden": "Nothing found. Try other words, English usually finds more.",
    "uebernehmen": "Use photo: {name}",
    "uebernimmt": "Adding …",
    "fehler": {
      "kein_schluessel": "No key has been added for this source yet. miraTEQ sets it up under Settings, Claude tab.",
      "gesperrt": "The source refused the request. Please try the other source or later.",
      "netz": "That did not work. Please try again.",
      "nicht_gefunden": "This photo no longer exists. Please choose another one.",
      "zu_gross": "The photo is too large. Please choose another one.",
      "kein_bild": "The file is not an image. Please choose another photo.",
      "verarbeitung": "The photo could not be converted. Please choose another one.",
      "quelle_unbekannt": "This source does not exist."
    }
  },
  "bildquellen": {
    "titel": "Stock photos",
    "text": "Keys for Pexels and Pixabay, both free. With them you and Claude find photos for the website. Photos are copied to the website itself, not embedded from there.",
    "schluessel_da": "Saved, ends in {ende}",
    "schluessel_fehlt": "No key saved",
    "neu": "New key for {quelle}",
    "speichern": "Save",
    "entfernen": "Remove",
    "gespeichert": "Saved",
    "fehler_format": "That does not look like a key. Please copy it again."
  },
  "symbol": {
    "titel": "Icon",
    "keins": "None",
    "haus": "House",
    "bad": "Bath",
    "schluessel": "Key",
    "palm": "Palm tree",
    "sand": "Beach",
    "lotus": "Lotus",
    "leaf": "Leaf",
    "compass": "Compass",
    "dining": "Dining",
    "concierge": "Service bell",
    "community": "Community",
    "award": "Award",
    "lock": "Lock",
    "coffee": "Coffee",
    "calendar": "Calendar",
    "bed": "Bed",
    "view": "View",
    "size": "Size",
    "guests": "Guests",
    "healing": "Wellbeing",
    "mandala": "Mandala",
    "herbs": "Herbs",
    "oil": "Oil",
    "candle": "Candle",
    "clock": "Clock",
    "phone": "Phone",
    "mail": "Mail",
    "map": "Map",
    "chat": "Chat",
    "wolke": "Cloud",
    "geld": "Money",
    "schild": "Shield"
  },
  "ki_bild": {
    "beschreibung": "What should the image show?",
    "beschreibung_platzhalter": "For example: Warm-lit massage room with a mat, folded towels and orchids, evening mood",
    "format": "Format",
    "format_quer": "Landscape (for the opening section)",
    "format_hoch": "Portrait",
    "format_quadrat": "Square",
    "erzeugen": "Create image",
    "laeuft": "Creating …",
    "laeuft_lang": "Google is creating the image, this takes about 10 to 30 seconds.",
    "uebrig": "{n} image left this month | {n} images left this month",
    "hinweis": "Created with AI by Google, about 10 cents per image. Never for photos of the team, staff or customers.",
    "ergebnis": "Created image",
    "fertig": "The image is now in the media library.",
    "nehmen": "Use this image",
    "fehler": {
      "nicht_eingerichtet": "AI images are not set up yet. miraTEQ sets up the access.",
      "grenze": "The limit for AI images this month has been reached. Please use a stock photo or your own image.",
      "beschreibung": "Please describe the image in at most 600 characters.",
      "abgelehnt": "Google declined this description. Please describe the image differently, for example without people.",
      "gesperrt": "Google refused the access. Please contact miraTEQ.",
      "netz": "That did not work. Please try again.",
      "kein_bild": "Google did not return an image. Please try again.",
      "verarbeitung": "The image could not be saved. Please try again."
    }
  },
  "anfragen": {
    "knopf": "Enquiries",
    "knopf_hinweis": "What visitors sent through the contact form",
    "titel": "Enquiries from the contact form",
    "frist": "Each enquiry also arrived by email. The CMS deletes it automatically after six months.",
    "laedt": "Loading enquiries …",
    "leer": "No enquiries yet. New ones appear here as soon as someone sends the contact form.",
    "email": "Email",
    "telefon": "Phone",
    "termin": "Preferred date",
    "personen": "People",
    "von_seite": "Sent from",
    "antworten": "Reply by email",
    "loeschen": "Delete",
    "loeschen_frage": "Delete this enquiry? This cannot be undone.",
    "ja_loeschen": "Yes, delete",
    "geloescht": "Enquiry deleted",
    "fehler_laden": "The enquiries could not be loaded. Please try again.",
    "fehler_loeschen": "The enquiry could not be deleted. Please reload the page."
  },
  "video": {
    "waehlen": "Choose a video (MP4 or WebM)",
    "laedt": "Uploading video …",
    "hochgeladen": "Video uploaded. Remember to save.",
    "entfernen": "Remove",
    "nur_mp4": "Please choose a video as MP4 or WebM.",
    "zu_gross": "The video is larger than 25 MB. Please save it shorter or smaller.",
    "hinweis": "Without sound, short and meant as a loop. The image stays underneath: it shows while the video loads and for everyone who has reduced motion or data saving switched on.",
    "hochladen_fuer": "Upload video for {feld}"
  },
  "markenprofil": {
    "knopf": "Brand profile",
    "titel": "Brand profile",
    "einleitung": "Claude gets it with every request so every text sounds the same. It is not shown on the website.",
    "feld": {
      "angebot": "What the business offers",
      "zielgruppe": "For whom",
      "ton": "Tone",
      "vermeiden": "What a text should never say",
      "fakten": "Fixed facts",
      "anrede": "Address in German"
    },
    "beispiel": {
      "angebot": "Thai massage and spa in Lindau, since 2015, three treatment rooms",
      "zielgruppe": "Locals and holiday guests who want to unwind",
      "ton": "calm, warm, without exaggeration",
      "vermeiden": "healing promises, “wellness oasis”",
      "fakten": "Owner: Malee Sommer, appointments only"
    },
    "anrede": {
      "offen": "as before",
      "sie": "formal (Sie)",
      "du": "informal (du)"
    },
    "speichern": "Save",
    "gespeichert": "Brand profile saved",
    "fehler_laden": "The brand profile could not be loaded.",
    "fehler_speichern": "The brand profile could not be saved. Your access may not be allowed to edit texts."
  },
  "sprachen": {
    "knopf": "Languages",
    "knopf_hinweis": "Add or release a language",
    "titel": "Languages of the website",
    "haupt": "Main language",
    "in_arbeit": "in progress",
    "live": "on the website",
    "mit_claude": "Translate with Claude",
    "freigeben": "Release",
    "hinzufuegen": "Add a language",
    "waehlen": "Choose a language",
    "anlegen": "Add",
    "hinweis": "All texts of the main language are copied as a starting point. The preview shows the new language right away; it goes live only after translation and “Release”.",
    "ergaenzt": "{name} added, {n} text file copied. | {name} added, {n} text files copied.",
    "freigegeben": "{name} is released and goes live with the next publish."
  }
}
